window.PopularData = [];

window.CheckIndexStatus = function(MainSession, loggedin)
{
    let CurrentUrl = new URL(window.location.href);

    if(CurrentUrl.searchParams.get("direct") != null)
    {
        if (typeof (window.history.replaceState) != "undefined")
        {
            window.history.replaceState(null, document.title, "/");
        }

        let DecodedURArray = atob(CurrentUrl.searchParams.get("direct")).split(" = ");
        //console.log(DecodedURArray);

        if(DecodedURArray[0] == "RES") // Reset Password ---------------------------------------
        {
            let WhatDayIsToday = window.GetAndConvertCurrentDate(true);

            let URLCheckResetPassword = "/v2/password/reset/verify?email=" + DecodedURArray[1] + "&create_at=" + WhatDayIsToday + "&member=" + DecodedURArray[2] + "&id_code=" + DecodedURArray[3] + "&code=" + DecodedURArray[4] + "&lang=" + window.CurrentCountryID;
            //console.log(URLCheckResetPassword);

            sessionStorage.setItem("PopUpDisplayed", true);

            window.InstantiateForgotPassword(DecodedURArray);
            window.LoadAllIndexInformation(MainSession, loggedin);
        }
        else if(DecodedURArray[0] == "VR" || DecodedURArray[0] == "AVR") // Verify Account/ Almost There -------------------------
        {
            let UserEmailNewRegistered = DecodedURArray[1];
            let IsNewverified = true;
            let UserInfoBlocker = window.InstantiateLoadingBlocker("UserInfoBlocker");
            
            if(DecodedURArray[0] == "AVR") // Verify ---------------------------------------------------------
            {
                IsNewverified = false;
            }

            (async () =>
            {
                if(UserEmailNewRegistered != null && await window.CheckEmailValidityBackEnd(UserEmailNewRegistered))
                {
                    let CheckEmailURL = "/v2/email/check";

                    let formData = new FormData();
                    formData.append('email', UserEmailNewRegistered);
                    formData.append('lang', window.CurrentCountryID);
                        
                    window.CallApiAxios({
                        method: "POST",
                        url: CheckEmailURL,
                        data: formData
                    }).then(res =>
                    {
                        let CheckEmailData = res.data.data;
                        //console.log(CheckEmailURL);
                        //console.log(CheckEmailData);

                        if(CheckEmailData.status_account == "Active" && CheckEmailData.password_null == true)
                        {
                            if(IsNewverified == true) // If New Verified User Instantiate The Almost There
                            {
                                AlmostThereInstantiate(UserEmailNewRegistered);
                            }
                            else // If The Link Still Valid, and User Already Verified
                            {
                                window.InstantiateLoginPanel(UserEmailNewRegistered);
                                window.LoadAllIndexInformation(null, false);
                            }
                        }
                        else
                        {
                            window.LoadAllIndexInformation(null, false);
                        }
                        UserInfoBlocker.remove();
                    })
                    .catch(err =>
                    {
                        //console.error(err);
                        UserInfoBlocker.remove();
                        window.LoadAllIndexInformation(null, false);
                    });
                }
            })();

            if(loggedin == true) // If Logged in Log Out Immediately ------------------------------------------
            {
                window.LogOutUserFunction(MainSession, false);
            }
        }
        else if(DecodedURArray[0] == "NEWRES" || DecodedURArray[0] == "NEWVER")
        {

        }
        else if(DecodedURArray[0] == "REG")
        {
            if (typeof (window.history.replaceState) != "undefined")
            {
                window.history.replaceState(null, document.title, "/");
            }
            window.InstantiateLoginPanel('');
        }
        else
        {
            window.LoadAllIndexInformation(MainSession, loggedin);
        }
        return
    }
    else
    {
        window.LoadAllIndexInformation(MainSession, loggedin);
    }
}

window.LoadAllIndexInformation = function(MainSession, loggedin)
{
    // Set Index Image UI ---------------------------------
    let MainBackgroundAnimateContainer = document.getElementById("MainBackgroundAnimateContainer");
    let MainTopBackground = document.getElementById("MainTopBackground");
    let LoadingTopBackground = document.getElementById("LoadingTopBackground");
    window.checkImageUrlValid("/Assets/images/AnimateBG/HeaderNew.jpg", "/Assets/images/NoImage.jpeg", MainTopBackground, () =>
    {
        window.CheckIfImageLoadedAndCallAFunction(MainBackgroundAnimateContainer, ()=>
        {
            if(LoadingTopBackground != null)
            LoadingTopBackground.remove();

            if(MainTopBackground != null)
            MainTopBackground.style.opacity = 1;
        });
    }, {});

    // Set Main Input -----------------------------------

    let WhatDayIsToday = new Date();
    let DayFullName = window["weekdayFull" + window.CurrentCountryID][WhatDayIsToday.getDay()];
    //console.log(WhatDayIsToday);

    let ThisYear = WhatDayIsToday.getFullYear();
    let ThisMonth = WhatDayIsToday.getMonth()+1;
    let ThisDate = WhatDayIsToday.getDate();
    let CheckInFullDate = new Date(ThisYear, ThisMonth-1, ThisDate);
    //console.log(ThisDate + "-" + ThisMonth + "-" + ThisYear);

    let WhatDayIsTomorrow = new Date();
    WhatDayIsTomorrow.setDate(WhatDayIsTomorrow.getDate() + 1);
    let DayFullNameTomorrow = window["weekdayFull" + window.CurrentCountryID][WhatDayIsTomorrow.getDay()];
    // //console.log(WhatDayIsTomorrow);

    let TomorrowYear = WhatDayIsTomorrow.getFullYear();
    let TomorrowMonth = WhatDayIsTomorrow.getMonth()+1;
    let TomorrowDate = WhatDayIsTomorrow.getDate();
    let CheckOutFullDate = new Date(TomorrowYear, TomorrowMonth-1, TomorrowDate)
    // //console.log(TomorrowDate + "-" + TomorrowMonth + "-" + TomorrowYear);

    let CheckInDateInput = document.getElementById("CheckInDateInput");
    CheckInDateInput.setAttribute("date", ThisDate);
    CheckInDateInput.setAttribute("month", ThisMonth);
    CheckInDateInput.setAttribute("year", ThisYear);
    document.getElementById("CheckInDateInputDateText").innerHTML = ThisDate + " " + window["monthNames" + window.CurrentCountryID][ThisMonth-1] + " " + ThisYear;
    document.getElementById("CheckInDateInputDayNameText").innerHTML = DayFullName;

    let CheckOutDateInput = document.getElementById("CheckOutDateInput");
    CheckOutDateInput.setAttribute("date", TomorrowDate);
    CheckOutDateInput.setAttribute("month", TomorrowMonth);
    CheckOutDateInput.setAttribute("year", TomorrowYear);
    document.getElementById("CheckOutDateInputDateText").innerHTML = TomorrowDate + " " + window["monthNames" + window.CurrentCountryID][TomorrowMonth-1] + " " + TomorrowYear;
    document.getElementById("CheckOutDateInputDayNameText").innerHTML = DayFullNameTomorrow;

    let RoomQuotaInput = parseInt(document.getElementById("RoomQuotaInput").getAttribute("room-quota"));
    let RoomQuotaTextToDisplay = RoomQuotaInput + " " + window["RoomTxt" + window.CurrentCountryID];
    if(RoomQuotaInput > 1)
    {
        RoomQuotaTextToDisplay = RoomQuotaInput + " " + window["RoomTxtex" + window.CurrentCountryID];
    }
    document.getElementById("RoomQuotaTextDisplay").innerHTML = RoomQuotaTextToDisplay;

    let DifferenceBetweenDays = window.GetDateDifferences(CheckOutFullDate, CheckInFullDate);
    let DiffDaysText = window.NightTextDisplayer(DifferenceBetweenDays);
    
    document.getElementById("HowManyNightText").innerHTML = DiffDaysText;

    // let RoomQuota = document.getElementById("RoomQuotaInput").setAttribute("room-quota", 1);

    // Check Inputted Data ------------------------------

    let InputFieldNameIndex = document.getElementById("MainSearchInputField");
    let SearchButtonIndex = document.getElementById("SearchButtonIndex");
  
    InputFieldNameIndex.addEventListener("keydown", function(event)
    {
        if (window.event.key === "Enter")
        {
            window.event.preventDefault();
            SearchButtonIndex.click();
        }
    });
  
    SearchButtonIndex.addEventListener("click", function()
    {
        window.OnSearchTopButtonClicked();
    });


    // ---------------------------------------------------

    let WhereToInstantiateAll = document.getElementById("MainContentIndex");
    WhereToInstantiateAll.innerHTML = "";

    // Login Sekarang ------------------------------------

    if(loggedin == false)
    {
        createLoginSekarangWarningSection(WhereToInstantiateAll);
    }

    // Prepare Popular Area ---------------------------------
    
    let PopularLoadingContainer = window.LoadingContentPanel(WhereToInstantiateAll, 1, 8);

    let PopularAreaMainContainer = document.createElement("div");
    PopularAreaMainContainer.className = "SectionSeparatorContainer";
    PopularAreaMainContainer.style.display = "none";
    WhereToInstantiateAll.append(PopularAreaMainContainer);
    
    // Slide Pop Up ---------------------------------

    let SlidePopUpContainer = document.createElement("div");
    SlidePopUpContainer.className = "SectionSeparatorContainer";
    SlidePopUpContainer.id = "SlidePopUpContainer";
    SlidePopUpContainer.style.display = "none";
    SlidePopUpContainer.style.padding = 0;
    WhereToInstantiateAll.append(SlidePopUpContainer);


    //LoadPopularArea(TempPopularData, PopularAreaMainContainer, PopularLoadingContainer)

    // Featured Hotel ---------------------------------
    
    let FeaturedHotelContainers = window.LoadingContentPanel(WhereToInstantiateAll, 3, 5);

    FeaturedHotelContainers[2].style.display = "";
    FeaturedHotelContainers[3].style.display = "none";
    FeaturedHotelContainers[4].style.display = "none";

    // Load Ads Panel ---------------------------------

    (async () =>
    {
        // Load Province --------------------------------

        await window.GetProvinceLoad(null);

        // Load Popular Area ---------------------------------

        await window.LoadPopularAreaData(PopularAreaMainContainer, PopularLoadingContainer, 1);

        // Load Slide Pop Up --------------------------------

        await LoadSlidePopUpInfo(SlidePopUpContainer);

        // Prepare Featured Hotel ---------------------------------

        await window.PrepareFeaturedHotel(FeaturedHotelContainers);

        // Trending Hotels ---------------------------------
        
        window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, "/hotels/home/popular-id", "PopularID", window["TrendingAccForYouTxt" + window.CurrentCountryID]);

        // Under 300K ---------------------------------
        
        window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, "/hotels/home/under-300", "Under300", window["AccUnder300KTxt" + window.CurrentCountryID]);

        //Gabung Sekarang ---------------------------------
        
        CreateGabungSekarangIndex(WhereToInstantiateAll)

        PreparePopUpInfo();
    })();
}


// Load Login Sekarang Orange Container =============================

function createLoginSekarangWarningSection(wheretoinstantiate)
{
    // Main container
    let mainDiv = document.createElement("div");
    mainDiv.className = "SectionSeparatorContainer LoginSekarangWarningSection";
    mainDiv.style.paddingBottom = 0;
    wheretoinstantiate.appendChild(mainDiv);

    // ===================== Desktop Orange Container =====================
    let orangeDesktop = document.createElement("div");
    orangeDesktop.className = "OrangeWarningContainer BasicRoundRadius HideOnMobile";
    mainDiv.appendChild(orangeDesktop);

    // flex wrapper for icon + text
    let flexWrap = document.createElement("div");
    flexWrap.style = "width: fit-content; height: fit-content; display: flex; margin:auto 0;";
    orangeDesktop.appendChild(flexWrap);

    let giftIconDesktop = document.createElement("img");
    giftIconDesktop.src = "/Assets/images/Icon/gift-box-login-sekarang.svg";
    giftIconDesktop.className = "BasicIconInsideOrangeContainer";
    giftIconDesktop.style.marginLeft = "0";
    flexWrap.appendChild(giftIconDesktop);

    let messageDesktop = document.createElement("p");
    messageDesktop.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    messageDesktop.style = "margin: auto 0; color: #344054;";
    messageDesktop.innerHTML = window["OrangeLoginNowIndexText" + window.CurrentCountryID];
    flexWrap.appendChild(messageDesktop);

    // right-side buttons container
    let userTopInfoDesktop = document.createElement("div");
    userTopInfoDesktop.className = "UserTopInfoWrapper SecondSectionLoginSekarang";
    userTopInfoDesktop.style = "height: fit-content; width: fit-content; margin: auto; margin-right: 0;";
    orangeDesktop.appendChild(userTopInfoDesktop);

    let masukBtnDesktop = document.createElement("button");
    masukBtnDesktop.className = "BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable";
    masukBtnDesktop.onclick = function()
    {
        window.InstantiateLoginPanel('');
    }
    masukBtnDesktop.innerHTML = window["LoginBtnText" + window.CurrentCountryID];
    userTopInfoDesktop.appendChild(masukBtnDesktop);

    let selengkapnyaBtn = document.createElement("button");
    selengkapnyaBtn.className = "BasicTextButton BasicBoxShadow SignInButtonTop Selectable";
    selengkapnyaBtn.style = "color: #475467; background-color: transparent;";
    userTopInfoDesktop.appendChild(selengkapnyaBtn);

    let selengkapnyaFlex = document.createElement("div");
    selengkapnyaFlex.style = "width: fit-content; height: fit-content; display: flex; margin: auto;";
    selengkapnyaBtn.appendChild(selengkapnyaFlex);

    let selengkapnyaText = document.createElement("p");
    selengkapnyaText.innerHTML = window["ReadMoreBtnText" + window.CurrentCountryID];
    selengkapnyaFlex.appendChild(selengkapnyaText);

    let helpIcon = document.createElement("img");
    helpIcon.src = "/Assets/images/ButtonIcon/help-icon.svg";
    helpIcon.className = "BasicIconInsideButton";
    helpIcon.style.marginRight = "0";
    selengkapnyaFlex.appendChild(helpIcon);

    // ===================== Mobile Orange Container =====================
    let orangeMobile = document.createElement("div");
    orangeMobile.className = "OrangeWarningContainer BasicRoundRadius ShowOnMobile";
    orangeMobile.style.flexDirection = "column";
    mainDiv.appendChild(orangeMobile);

    let firstSectionMobile = document.createElement("div");
    firstSectionMobile.className = "FirstSectionLoginSekarang";
    orangeMobile.appendChild(firstSectionMobile);

    let giftIconMobile = document.createElement("img");
    giftIconMobile.src = "/Assets/images/Icon/gift-box-login-sekarang.svg";
    giftIconMobile.className = "BasicIconInsideOrangeContainer";
    giftIconMobile.style.marginLeft = "0";
    firstSectionMobile.appendChild(giftIconMobile);

    let textWrapper = document.createElement("div");
    firstSectionMobile.appendChild(textWrapper);

    let mobileTitle = document.createElement("p");
    mobileTitle.className = "LabelGreyHeaderText InterMediumTextFont";
    mobileTitle.style.color = "#344054";
    mobileTitle.innerHTML = window["OrangeIndexMobileHeadTxt" + window.CurrentCountryID];
    textWrapper.appendChild(mobileTitle);

    let mobileDesc = document.createElement("p");
    mobileDesc.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    mobileDesc.innerHTML = window["OrangeIndexMobileMesTxt" + window.CurrentCountryID];
    textWrapper.appendChild(mobileDesc);

    let userTopInfoMobile = document.createElement("div");
    userTopInfoMobile.className = "UserTopInfoWrapper SecondSectionLoginSekarang";
    userTopInfoMobile.style = "height: fit-content; width: 100%;";
    orangeMobile.appendChild(userTopInfoMobile);

    let masukBtnMobile = document.createElement("button");
    masukBtnMobile.className = "BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable";
    masukBtnMobile.onclick = function()
    {
        window.InstantiateLoginPanel('');
    }
    masukBtnMobile.style.width = "100%";
    masukBtnMobile.innerHTML = window["LoginBtnText" + window.CurrentCountryID];
    userTopInfoMobile.appendChild(masukBtnMobile);

    return mainDiv;
}

function CreateGabungSekarangIndex(wheretoinstantiate)
{
    let MainSectionContainer = document.createElement("div");
    MainSectionContainer.className = "SectionSeparatorContainer";
    wheretoinstantiate.append(MainSectionContainer);

    let MainSectionWrapper = document.createElement("div");
    MainSectionWrapper.className = "SectionContentWrapper";
    MainSectionContainer.append(MainSectionWrapper);

    let DaftarkanContentContainer = document.createElement("div");
    DaftarkanContentContainer.className = "DaftarkanContentContainer";
    MainSectionWrapper.append(DaftarkanContentContainer);

    let MovableContainer = document.createElement("div");
    MovableContainer.className = "move-rect";
    DaftarkanContentContainer.append(MovableContainer);

    let MovableIMG = document.createElement("img");
    MovableIMG.style.opacity = 0;
    MovableContainer.append(MovableIMG);

    let LoadingGreyCover = document.createElement("div");
    LoadingGreyCover.className = "loading_grey ImageFullCover";
    DaftarkanContentContainer.append(LoadingGreyCover);

    window.checkImageUrlValid("/Assets/images/AnimateBG/DaftarkanImage.jpg", "/Assets/images/NoHotelImage.jpg", MovableIMG, () =>
    {
        window.CheckIfImageLoadedAndCallAFunction(MainSectionContainer, ()=>
        {
            LoadingGreyCover.remove();
            MovableIMG.style.opacity = 1;
        });
    }, {});

    let DaftarkanDescContainer = document.createElement("div"); // Desc Container
    DaftarkanDescContainer.className = "DaftarkanDescContainer";
    DaftarkanContentContainer.append(DaftarkanDescContainer);

    let DaftarkanHeaderText = document.createElement("p");
    DaftarkanHeaderText.className = "SectionHeaderTextIndex2 InterMediumTextFont";
    DaftarkanHeaderText.innerHTML =  window["DaftarkanAkomodasiBottomPartMessage" + window.CurrentCountryID] + " <img src='/Assets/images/Icon/pingingo-icon.svg'>";
    DaftarkanDescContainer.append(DaftarkanHeaderText);

    let DaftarkanMessageText = document.createElement("p");
    DaftarkanMessageText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    DaftarkanMessageText.innerHTML = window["ShowCaseYourAccBottomPartMessage" + window.CurrentCountryID];
    DaftarkanDescContainer.append(DaftarkanMessageText);

    let DaftarkanButton = document.createElement("button");
    DaftarkanButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    DaftarkanButton.innerHTML = window["GabungSekarangBottomPart" + window.CurrentCountryID];
    DaftarkanDescContainer.append(DaftarkanButton);

    let DaftarkanHREF = document.createElement("a");
    DaftarkanHREF.className = "HREFInsideContainer";
    DaftarkanHREF.href = "https://listing.pingingo.com/" + window.CurrentCountryID;
    DaftarkanButton.append(DaftarkanHREF);


    // Assign Moveable Function -----------------------------------

    window.$(document).ready(function ()
    {
        let $container = window.$(DaftarkanContentContainer);
        let $moveable = window.$(MovableContainer);

        window.$(document).mousemove(function (e)
        {
            var offset = $container.offset();
            var relX = e.pageX - offset.left;
            var relY = e.pageY - offset.top;

            var centerX = $container.width() / 2;
            var centerY = $container.height() / 2;

            var moveX = (relX - centerX) / -20;
            var moveY = (relY - centerY) / -20;

            $moveable.css({
                transform: `translate(-50%, -50%) translate(${moveX}px, ${moveY}px)`
            });
        });

    });
}

// Popular Area ======================================================

window.LoadPopularAreaData = async function(PopularAreaMainContainer, PopularLoadingContainer, howmanytries)
{
    let LoadPopularURL = "/v2/hotels/city-region";

    try
    {
        const res = await window.CallApiAxios({
            method: "GET",
            url: LoadPopularURL,
        });

        //console.log("Load Popular Area________________")
        window.PopularData = res.data.data;
        //console.log(window.PopularData);

        if (res.status == 200 && window.PopularData.length > 0)
        {
            window.InstantiatePopularArea(window.PopularData, PopularAreaMainContainer, PopularLoadingContainer);
        }
        else
        {
            PopularLoadingContainer.remove();
            PopularAreaMainContainer.remove();
        }
    }
    catch (err)
    {
        //console.error(err);
        PopularLoadingContainer.remove();
        PopularAreaMainContainer.remove();
    }
}

window.InstantiatePopularArea = function(ThisPopularArea, PopularAreaMainContainer, PopularLoadingContainer)
{
    // Delete The Loading Initial ----------------------------------
    
    PopularLoadingContainer.remove();
    PopularAreaMainContainer.style.display = "";
    
    // Load the Container --------------------------------

    let SectionContentWrapper = document.createElement("div");
    SectionContentWrapper.className = "SectionContentWrapper";
    PopularAreaMainContainer.append(SectionContentWrapper);

    let PopularAreaHeaderText = document.createElement("p");
    PopularAreaHeaderText.className = "SectionHeaderTextIndex InterRegularTextFont";
    PopularAreaHeaderText.innerHTML = window["PopularDestinationHeader" + window.CurrentCountryID];
    SectionContentWrapper.append(PopularAreaHeaderText);

    let PopularAreaMessageText = document.createElement("p");
    PopularAreaMessageText.className = "SectionHeaderTextIndex LabelGreyHeaderSmallerText InterRegularTextFont HideOnMobile";
    PopularAreaMessageText.innerHTML = window["PopularDestinationMes" + window.CurrentCountryID];
    SectionContentWrapper.append(PopularAreaMessageText);

    let BasicPanelSwiperMainContainer = document.createElement("div");
    BasicPanelSwiperMainContainer.className = "BasicPanelSwiperMainContainer";
    SectionContentWrapper.append(BasicPanelSwiperMainContainer);

    let ContainerWithMaskEdge = document.createElement("div");
    ContainerWithMaskEdge.className = "ContainerWithMaskEdge PopularAreasMask";
    BasicPanelSwiperMainContainer.append(ContainerWithMaskEdge);

    let PopularAreasPanelContainer = document.createElement("div");
    PopularAreasPanelContainer.className = "PopularAreasPanelContainer";
    ContainerWithMaskEdge.append(PopularAreasPanelContainer);

    let PopularAreasPanelWrapper = document.createElement("div");
    PopularAreasPanelWrapper.className = "swiper-wrapper";
    PopularAreasPanelContainer.append(PopularAreasPanelWrapper);

    for(let i = 0; i < ThisPopularArea.length; i++)
    {
        let PopularLoadingPanel = window.InstantiateLoadingPopularPanel(PopularAreasPanelWrapper);

        let PopularAreasPanel = document.createElement("div");
        PopularAreasPanel.className = "PopularAreasPanel swiper-slide Unselectable";
        PopularAreasPanel.style.display = "none";
        PopularAreasPanelWrapper.append(PopularAreasPanel);

        let PopularAreasInformationPanel = document.createElement("div");
        PopularAreasInformationPanel.className = "PopularAreasInformationPanel";
        PopularAreasPanel.append(PopularAreasInformationPanel);

        let PopularAreasImageContainer = document.createElement("div");
        PopularAreasImageContainer.className = "PopularAreasImageContainer";
        PopularAreasInformationPanel.append(PopularAreasImageContainer);

        let ImageFullCover = document.createElement("img");
        ImageFullCover.className = "PopularAreasImage";
        ImageFullCover.setAttribute("is-valid", 'false');
        window.checkImageUrlValid(ThisPopularArea[i]?.photo[0]?.area_photo, "/Assets/images/NoImage.jpeg", ImageFullCover, () =>
        {
            window.CheckIfImageLoadedAndCallAFunction(PopularAreasPanel, ()=>
            {
                PopularLoadingPanel.remove();
                PopularAreasPanel.style.display = "";
            });
        }, { quality: 70});
        PopularAreasImageContainer.append(ImageFullCover);

        let NameofHotelPopularArea = document.createElement("p");
        NameofHotelPopularArea.className = "NameofHotelPopularArea InterBoldTextFont";
        NameofHotelPopularArea.innerHTML = ThisPopularArea[i].city_region;
        PopularAreasInformationPanel.append(NameofHotelPopularArea);

        let HowManyHotelLeftPopularArea = document.createElement("p");
        HowManyHotelLeftPopularArea.className = "HowManyHotelLeftPopularArea InterRegularTextFont";
        HowManyHotelLeftPopularArea.innerHTML = ThisPopularArea[i].jumlah_hotel + " " + window["AccommodationTxt" + window.CurrentCountryID];
        if(ThisPopularArea[i].jumlah_hotel > 1)
        {
            HowManyHotelLeftPopularArea.innerHTML = ThisPopularArea[i].jumlah_hotel + " " + window["AccommodationTxtex" + window.CurrentCountryID];
        }
        PopularAreasInformationPanel.append(HowManyHotelLeftPopularArea);


        let CheckInDateInput = document.getElementById("CheckInDateInput");
        let CheckInDate = CheckInDateInput.getAttribute("date");
        let CheckInMonth = CheckInDateInput.getAttribute("month");
        let CheckInYear = CheckInDateInput.getAttribute("year");
        let CheckInFullDate = CheckInYear + "-" + CheckInMonth.padStart(2, '0') + "-" + CheckInDate;
        let CheckOutDateInput = document.getElementById("CheckOutDateInput");
        let CheckOutDate = CheckOutDateInput.getAttribute("date");
        let CheckOutMonth = CheckOutDateInput.getAttribute("month");
        let CheckOutYear = CheckOutDateInput.getAttribute("year");
        let CheckOutFullDate = CheckOutYear + "-" + CheckOutMonth.padStart(2, '0') + "-" + CheckOutDate;
        let RoomQuota = document.getElementById("RoomQuotaInput").getAttribute("room-quota");
        let HREFUrl = "/search/" + window.CurrentCountryID + "/" +  ThisPopularArea[i].province_slug + ".html?search=" + ThisPopularArea[i].province + "&checkin=" + CheckInFullDate + "&checkout=" + CheckOutFullDate + "&room=" +  RoomQuota + "&area="+ ThisPopularArea[i].city_region;

        let PopularAreaHREF = document.createElement("a");
        PopularAreaHREF.className = "HREFInsideContainer";
        PopularAreaHREF.href = HREFUrl;
        PopularAreasInformationPanel.append(PopularAreaHREF);
    }

    let PrevButtonPopularSwiper = document.createElement("div");
    PrevButtonPopularSwiper.className = "PopularAreasLeftRightButtonContainer PaddingButtonLeft";
    BasicPanelSwiperMainContainer.append(PrevButtonPopularSwiper);

    let PrevButtonPopular = document.createElement("button");
    PrevButtonPopular.className = "NextPreviousSwiperButton Selectable2 PopularAreaButtonLeft";
    PrevButtonPopularSwiper.append(PrevButtonPopular);

    let PrevButtonPopularIMG = document.createElement("img");
    PrevButtonPopularIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
    PrevButtonPopular.append(PrevButtonPopularIMG);

    let NextButtonPopularSwiper = document.createElement("div");
    NextButtonPopularSwiper.className = "PopularAreasLeftRightButtonContainer PaddingButtonRight";
    BasicPanelSwiperMainContainer.append(NextButtonPopularSwiper);

    let NextButtonPopular = document.createElement("button");
    NextButtonPopular.className = "NextPreviousSwiperButton Selectable2 PopularAreaButtonRight";
    NextButtonPopularSwiper.append(NextButtonPopular);

    let NextButtonPopularIMG = document.createElement("img");
    NextButtonPopularIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
    NextButtonPopular.append(NextButtonPopularIMG);

    let PopularSwiper = new window.Swiper(PopularAreasPanelContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: PrevButtonPopular,
            nextEl: NextButtonPopular,
        }
    });
}

// Featured Hotel ===================================================

window.window.FeaturedHotelAjax = [];

window.PrepareFeaturedHotel = async function(FeaturedHotelContainers)
{
    let HowManyLoaded = [];

    // FeaturedHotelContainers[2].style.display = "";
    // FeaturedHotelContainers[3].style.display = "none";
    // FeaturedHotelContainers[4].style.display = "none";

    await window.GetProvinceLoad(null);

    if(window.provincePromise = null)
    {
        FeaturedHotelContainers[0].style.display = "none";
        FeaturedHotelContainers[1].style.display = "none";
        FeaturedHotelContainers[2].style.display = "none";
        FeaturedHotelContainers[3].style.display = "";
        FeaturedHotelContainers[4].style.display = "none";
    }
    else
    {
        let FeaturedHotelHeaderText = document.createElement("p");
        FeaturedHotelHeaderText.className = "SectionHeaderTextIndex InterRegularTextFont";
        FeaturedHotelHeaderText.innerHTML = window["RecommendedHotelHeader" + window.CurrentCountryID];
        FeaturedHotelContainers[1].append(FeaturedHotelHeaderText);

        let FeaturedHotelButtoMask = document.createElement("div");
        FeaturedHotelButtoMask.className = "ContainerWithMaskEdge";
        FeaturedHotelContainers[1].append(FeaturedHotelButtoMask);

        let FeaturedButtonContainer = document.createElement("div");
        FeaturedButtonContainer.className = "FeaturedButtonContainer";
        FeaturedHotelButtoMask.append(FeaturedButtonContainer);

        let FeaturedButtonWrapper = document.createElement("div");
        FeaturedButtonWrapper.className = "swiper-wrapper";
        FeaturedButtonContainer.append(FeaturedButtonWrapper);

        for(let j = 0; j <window.CurrentExistingSearchList.length; j++)
        {
            let FeaturedButtonIndex = document.createElement("button");
            FeaturedButtonIndex.className = "FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide";
            FeaturedButtonIndex.innerHTML = window.CurrentExistingSearchList[j].province;
            FeaturedButtonIndex.style.width = "fit-content";
            FeaturedButtonIndex.onclick = function()
            {
                ChangeFeaturedHotelToDisplay(window.CurrentExistingSearchList[j], FeaturedButtonWrapper, FeaturedHotelContainers);
            }
            FeaturedButtonWrapper.append(FeaturedButtonIndex);
        }
        //console.log(FeaturedHotelContainers);

        FeaturedHotelContainers[0].style.display = "none";
        FeaturedHotelContainers[1].style.display = "";
        FeaturedHotelContainers[2].style.display = "none";
        FeaturedHotelContainers[4].style.display = "";

        ChangeFeaturedHotelToDisplay(window.CurrentExistingSearchList[0], FeaturedButtonWrapper, FeaturedHotelContainers);
    }
}

function ChangeFeaturedHotelToDisplay(whichdata, FeaturedButtonWrapper, FeaturedHotelContainers)
{
    // //console.log("============== TEST ==============");
    // //console.log(window.FeaturedHotelAjax);
    // if(window.FeaturedHotelAjax != null)
    // window.FeaturedHotelAjax.abort()

    // Change the Button ----------------------
    let ThisFeaturedButtons = FeaturedButtonWrapper.querySelectorAll('.FeaturedButtonIndex');
    ThisFeaturedButtons.forEach(ThisFeaturedButton =>
    {
        ThisFeaturedButton.style.width = "fit-content";
        ThisFeaturedButton.className = "FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide";
        if(ThisFeaturedButton.innerHTML == whichdata.province)
        {
            ThisFeaturedButton.className = "FeaturedButtonIndex FeaturedButtonSelected InterBoldTextFont Selectable swiper-slide";
        }
    });


    // Load And Instantiate The Panel ------------------------

    if(whichdata.jumlah_hotel > 0)
    {
        let PanelWrapper = FeaturedHotelContainers[4].querySelectorAll('.swiper-wrapper')[0];
        PanelWrapper.innerHTML = "";

        window.CurrentIndexFeaturedHotel = 1;
        window.FeaturedHotelSwiper.off('reachEnd');
        window.LoadFeaturedHotelProvince(whichdata.province_slug, PanelWrapper, FeaturedHotelContainers);
    }
    else
    {
        FeaturedHotelContainers[2].style.display = "none";
        FeaturedHotelContainers[3].style.display = "";
        FeaturedHotelContainers[4].style.display = "none";
    }
}


window.FeaturedHotelSwiper = null;
window.CurrentIndexFeaturedHotel = 1;

window.LoadFeaturedHotelProvince = function(whichprovinceslug, PanelWrapper, FeaturedHotelContainers)
{
    let LoadingTempInstantiated = [];
    for(let i = 0; i < window.limitPanelPerPage; i++)
    {
        LoadingTempInstantiated.push(window.InstantiateLoadingBasicPanel(PanelWrapper));
    }

    let URLLoadThisFeaturedHotel = "/v2/hotels/home/recommendation/" + whichprovinceslug + "?page=" + window.CurrentIndexFeaturedHotel + "&limit=" + window.limitPanelPerPage;

    window.CallApiAxios({
        method: "GET",
        url: URLLoadThisFeaturedHotel,
    }).then(res =>
    {
        //console.log(URLLoadThisFeaturedHotel);
        //console.log(res);

        if(res.status == 200)
        {
            let ThisHotelData = res.data.data;

            LoadingTempInstantiated.forEach(loadingtemp => {
                loadingtemp.remove();
            });

            if(window.CurrentIndexFeaturedHotel == 1 && ThisHotelData.length == 0)
            {
                FeaturedHotelContainers[3].style.display = "";
                FeaturedHotelContainers[4].style.display = "none";
            }
            else
            {
                FeaturedHotelContainers[3].style.display = "none";
                FeaturedHotelContainers[4].style.display = "";

                window.InstantiateBasicHotelPanel2(ThisHotelData, PanelWrapper, FeaturedHotelContainers[4]);

                if(window.CurrentIndexFeaturedHotel == 1)
                {
                    window.FeaturedHotelSwiper.on('reachEnd', function ()
                    {
                        if (res.data.pagination.last_page == null || window.CurrentIndexFeaturedHotel < res.data.pagination.last_page)
                        {
                            window.CurrentIndexFeaturedHotel++;

                            window.LoadFeaturedHotelProvince(whichprovinceslug, PanelWrapper, FeaturedHotelContainers);
                        }
                    });
                }
            }
        }
    })
    .catch(err =>
    {
        //console.error(err);
        LoadingTempInstantiated.forEach(loadingtemp =>
        {
            loadingtemp.remove();
        });
    });
}

// =================================== ALMOST THERE =======================================

function AlmostThereInstantiate(EmailGet)
{
    let DontDuplicatePanel = document.getElementById("BlockerLoginPanelSectionMain");
    if(DontDuplicatePanel != null)
        DontDuplicatePanel.remove();

    let AlmostThereBlockerContainer = document.createElement("div");
    AlmostThereBlockerContainer.className = "AlmostThereBlockerContainer";
    document.getElementsByTagName("body")[0].append(AlmostThereBlockerContainer);

    // Left Section ===============================================================================

    let AlmostImageLeftWrapper = document.createElement("div");
    AlmostImageLeftWrapper.className = "AlmostImageLeftWrapper";
    AlmostThereBlockerContainer.append(AlmostImageLeftWrapper);

    let AlmostImageBGContainer = document.createElement("div");
    AlmostImageBGContainer.className = "AlmostImageBGContainer";
    AlmostImageLeftWrapper.append(AlmostImageBGContainer);

    for(let i = 1; i < 5; i++)
    {
        let MainBackgroundAnimate = document.createElement("img");
        MainBackgroundAnimate.className = "MainBackgroundAnimate";
        MainBackgroundAnimate.src = "/Assets/images/AnimateBG/" + i + ".jpg";
        MainBackgroundAnimate.style.opacity = 0;
        AlmostImageBGContainer.append(MainBackgroundAnimate);

        if(i == 1)
        MainBackgroundAnimate.style.opacity = 1;
    }
    window.AutoAnimateIMGInsidePanel(AlmostImageBGContainer);

    let PinginGoIconAlmostThere = document.createElement("img");
    PinginGoIconAlmostThere.className = "PinginGoIconAlmostThere";
    AlmostImageLeftWrapper.append(PinginGoIconAlmostThere);


    // Right Section ===============================================================================
    
    let AlmostFormContainer = document.createElement("div");
    AlmostFormContainer.className = "AlmostFormContainer";
    AlmostThereBlockerContainer.append(AlmostFormContainer);

    let TopBarAlmostPanel = document.createElement("div");
    TopBarAlmostPanel.className = "TopBarAlmostPanel";
    AlmostFormContainer.append(TopBarAlmostPanel);

    let PinginGoIconAlmostThereTopBar = document.createElement("img");
    PinginGoIconAlmostThereTopBar.className = "PinginGoIconAlmostThere";
    PinginGoIconAlmostThereTopBar.src = "/Assets/images/Icon/verified-company-logo.svg";
    TopBarAlmostPanel.append(PinginGoIconAlmostThereTopBar);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel BasicShadow2";
    AlmostFormContainer.append(FlexFullDisplayPanel);


    // All Main Container ============================================================================================================================

    let CreatePasswordStepsWrapper = document.createElement("div");
    CreatePasswordStepsWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    CreatePasswordStepsWrapper.id = "CreatePasswordStepsWrapper";
    CreatePasswordStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(CreatePasswordStepsWrapper);

    let AlmostThereStepsWrapper = document.createElement("div");
    AlmostThereStepsWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    AlmostThereStepsWrapper.id = "AlmostThereStepsWrapper";
    AlmostThereStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(AlmostThereStepsWrapper);

    let YourAccountSuccessWrapper = document.createElement("div");
    YourAccountSuccessWrapper.className = "FlexContainerBaseAnimate FinalConfirmationWrapper";
    YourAccountSuccessWrapper.id = "YourAccountSuccessWrapper";
    YourAccountSuccessWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(YourAccountSuccessWrapper);


    window.MovePanelInsideContainerNext(null, CreatePasswordStepsWrapper, FlexFullDisplayPanel, null);

    // ===============================  Create Password ===============================

    let CreatePasswordGreenCircle = document.createElement("img");
    CreatePasswordGreenCircle.className = "CheckSuccessGreenCircle";
    CreatePasswordGreenCircle.src = "/Assets/images/Icon/check-grey-circle.svg";
    CreatePasswordStepsWrapper.append(CreatePasswordGreenCircle);

    let CreatePasswordStepsHeader = document.createElement("p");
    CreatePasswordStepsHeader.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    CreatePasswordStepsHeader.style="width: fit-content; margin: 0 auto;";
    CreatePasswordStepsHeader.innerHTML = window["YourAccountHasVerified" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(CreatePasswordStepsHeader);

    let CreatePasswordStepsDescription = document.createElement("p");
    CreatePasswordStepsDescription.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    CreatePasswordStepsDescription.style="color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    CreatePasswordStepsDescription.innerHTML =  window["ThankYouForVerifiedMes" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(CreatePasswordStepsDescription);

    let CreatePasswordStepsPasswordWrapper = document.createElement("div"); // Password ----
    CreatePasswordStepsPasswordWrapper.className = "BasicHeaderAndInputWrapper";
    CreatePasswordStepsWrapper.append(CreatePasswordStepsPasswordWrapper);

    let CreatePasswordStepsPasswordHeader = document.createElement("p");
    CreatePasswordStepsPasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    CreatePasswordStepsPasswordHeader.innerHTML = window["PasswordHeaderText" + window.CurrentCountryID];
    CreatePasswordStepsPasswordWrapper.append(CreatePasswordStepsPasswordHeader);

    let CreatePasswordStepsPasswordInputContainer = document.createElement("div");
    CreatePasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    CreatePasswordStepsPasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    CreatePasswordStepsPasswordInputContainer.id = "AlmostThereNewPasswordInputContainer";
    CreatePasswordStepsPasswordWrapper.append(CreatePasswordStepsPasswordInputContainer);

    let CreatePasswordStepsPasswordInputField = document.createElement("input");
    CreatePasswordStepsPasswordInputField.type = "password";
    CreatePasswordStepsPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    CreatePasswordStepsPasswordInputField.placeholder = window["NewPasswordPlaceholderTxt" + window.CurrentCountryID];
    CreatePasswordStepsPasswordInputField.style.outline = 0;
    CreatePasswordStepsPasswordInputField.id = "AlmostThereNewPasswordInputField";
    CreatePasswordStepsPasswordInputContainer.append(CreatePasswordStepsPasswordInputField);

    let CreatePasswordStepsPasswordInputIcon = document.createElement("img");
    CreatePasswordStepsPasswordInputIcon.className = "BasicIconInsideInput2";
    CreatePasswordStepsPasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    CreatePasswordStepsPasswordInputIcon.style.marginLeft = 0;
    CreatePasswordStepsPasswordInputContainer.append(CreatePasswordStepsPasswordInputIcon);

    let AlmostThereNewPasswordWarningText = document.createElement("p");
    AlmostThereNewPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereNewPasswordWarningText.id = "AlmostThereNewPasswordWarningText";
    CreatePasswordStepsPasswordWrapper.append(AlmostThereNewPasswordWarningText);


    let ConfirmPasswordStepsPasswordWrapper = document.createElement("div"); // Confirm Password ----
    ConfirmPasswordStepsPasswordWrapper.className = "BasicHeaderAndInputWrapper";
    CreatePasswordStepsWrapper.append(ConfirmPasswordStepsPasswordWrapper);

    let ConfirmPasswordStepsPasswordHeader = document.createElement("p");
    ConfirmPasswordStepsPasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    ConfirmPasswordStepsPasswordHeader.innerHTML = window["ReenterPasswordHeaderText" + window.CurrentCountryID];
    ConfirmPasswordStepsPasswordWrapper.append(ConfirmPasswordStepsPasswordHeader);

    let ConfirmPasswordStepsPasswordInputContainer = document.createElement("div");
    ConfirmPasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    ConfirmPasswordStepsPasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    ConfirmPasswordStepsPasswordInputContainer.id = "AlmostThereConfirmPasswordInputContainer";
    ConfirmPasswordStepsPasswordWrapper.append(ConfirmPasswordStepsPasswordInputContainer);

    let ConfirmPasswordStepsPasswordInputField = document.createElement("input");
    ConfirmPasswordStepsPasswordInputField.type = "password";
    ConfirmPasswordStepsPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    ConfirmPasswordStepsPasswordInputField.placeholder = window["ReenterPasswordPlaceholderTxt" + window.CurrentCountryID];
    ConfirmPasswordStepsPasswordInputField.style.outline = 0;
    ConfirmPasswordStepsPasswordInputField.id = "AlmostThereConfirmPasswordInputField";
    ConfirmPasswordStepsPasswordInputContainer.append(ConfirmPasswordStepsPasswordInputField);

    let ConfirmPasswordStepsPasswordInputIcon = document.createElement("img");
    ConfirmPasswordStepsPasswordInputIcon.className = "BasicIconInsideInput2";
    ConfirmPasswordStepsPasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    ConfirmPasswordStepsPasswordInputIcon.style.marginLeft = 0;
    ConfirmPasswordStepsPasswordInputContainer.append(ConfirmPasswordStepsPasswordInputIcon);

    let AlmostThereConfirmPasswordWarningText = document.createElement("p");
    AlmostThereConfirmPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereConfirmPasswordWarningText.id = "AlmostThereConfirmPasswordWarningText";
    ConfirmPasswordStepsPasswordWrapper.append(AlmostThereConfirmPasswordWarningText);

    let ConfirmPasswordNextButton = document.createElement("button"); // Next Button ----
    ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    ConfirmPasswordNextButton.style.margin = "0 auto";
    ConfirmPasswordNextButton.innerHTML =  window["ContinueTxt" + window.CurrentCountryID];
    ConfirmPasswordNextButton.id = "AlmostThereConfirmPasswordNextButton";
    CreatePasswordStepsWrapper.append(ConfirmPasswordNextButton);

    let TermsAndConditionCreatePasswordSection = document.createElement("p"); // Terms & Condition ----
    TermsAndConditionCreatePasswordSection.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionCreatePasswordSection.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionCreatePasswordSection.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(TermsAndConditionCreatePasswordSection);

    // -------------------------------------- ADD FUNCTION 1 (CREATE NEW PASSWORD) --------------------------------------

    // Create Password ---------------------------------------------------
    CreatePasswordStepsPasswordInputIcon.onclick = function() // Hide and Show Password -----------------------------
    {
        if(CreatePasswordStepsPasswordInputField.type == "password")
        {
            CreatePasswordStepsPasswordInputField.type = "text";
        }
        else
        {
            CreatePasswordStepsPasswordInputField.type = "password";
        }
    }

    CreatePasswordStepsPasswordInputField.onfocus = function(event) // On Input -----------------------------
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        AlmostThereNewPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        CreatePasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    CreatePasswordStepsPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(1, true, EmailGet);
    });

    // Confirm Password ---------------------------------------------------
    ConfirmPasswordStepsPasswordInputIcon.onclick = function() // Hide and Show Password -----------------------------
    {
        if(ConfirmPasswordStepsPasswordInputField.type == "password")
        {
            ConfirmPasswordStepsPasswordInputField.type = "text";
        }
        else
        {
            ConfirmPasswordStepsPasswordInputField.type = "password";
        }
    }

    ConfirmPasswordStepsPasswordInputField.onfocus = function(event) // On Input -----------------------------
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        AlmostThereConfirmPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        ConfirmPasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    ConfirmPasswordStepsPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(1, true, EmailGet);
    });

    // Push Pasword Button ---------------------------------------------------
    ConfirmPasswordNextButton.onclick = function()
    {
        let PushPasswordBlocker = window.InstantiateLoadingBlocker("PushPasswordBlocker");
        window.PushNewUserPassword(PushPasswordBlocker, FlexFullDisplayPanel, CreatePasswordStepsWrapper, EmailGet, CreatePasswordStepsPasswordInputField, ()=> window.MovePanelInsideContainerNext(CreatePasswordStepsWrapper, AlmostThereStepsWrapper, FlexFullDisplayPanel, function(){PushPasswordBlocker.remove()}));
    }

    // ===============================  ALMOST THERE ===============================

    let AlmostThereStepsWrapperFlex = document.createElement("div");
    AlmostThereStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    AlmostThereStepsWrapper.append(AlmostThereStepsWrapperFlex);

    let AlmostThereCloseButton = document.createElement("img");
    AlmostThereCloseButton.className = "CloseButtonInsidePanel Selectable2";
    AlmostThereCloseButton.id = "AlmostThereCloseButton";
    AlmostThereCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    AlmostThereStepsWrapperFlex.append(AlmostThereCloseButton);

    let AlmostThereStepsHeader = document.createElement("p");
    AlmostThereStepsHeader.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    AlmostThereStepsHeader.style="width: fit-content; margin: 0 auto;";
    AlmostThereStepsHeader.innerHTML = window["AlmostDoneHeaderText" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(AlmostThereStepsHeader);

    let AlmostThereStepsDescription = document.createElement("p");
    AlmostThereStepsDescription.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    AlmostThereStepsDescription.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    AlmostThereStepsDescription.innerHTML = window["ThankYouForVerThenCompleteProf" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(AlmostThereStepsDescription);

    let AlmostThereFirstLastNameWrapper = document.createElement("div"); // First Name & Last Name
    AlmostThereFirstLastNameWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereFirstLastNameWrapper);

    let AlmostThereFirstNameWrapper = document.createElement("div");
    AlmostThereFirstNameWrapper.className = "TwoSeparatorContent";
    AlmostThereFirstLastNameWrapper.append(AlmostThereFirstNameWrapper);

    let AlmostThereFirstNameHeaderText = document.createElement("p");
    AlmostThereFirstNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereFirstNameHeaderText.innerHTML = window["FirstNameTxt" + window.CurrentCountryID];
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameHeaderText);

    let AlmostThereFirstNameInputContainer = document.createElement("div");
    AlmostThereFirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AlmostThereFirstNameInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereFirstNameInputContainer.id = "AlmostThereFirstNameInputContainer";
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameInputContainer);

    let AlmostThereFirstNameInputField = document.createElement("input");
    AlmostThereFirstNameInputField.type = "text";
    AlmostThereFirstNameInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereFirstNameInputField.placeholder = window["InputFirstNamePlaceholder" + window.CurrentCountryID];
    AlmostThereFirstNameInputField.id = "AlmostThereFirstNameInputField";
    AlmostThereFirstNameInputContainer.append(AlmostThereFirstNameInputField);

    let AlmostThereFirstNameWarningText = document.createElement("p");
    AlmostThereFirstNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereFirstNameWarningText.id = "AlmostThereFirstNameWarningText";
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameWarningText);


    let AlmostThereLastNameWrapper = document.createElement("div"); // Last Name
    AlmostThereLastNameWrapper.className = "TwoSeparatorContent";
    AlmostThereFirstLastNameWrapper.append(AlmostThereLastNameWrapper);

    let AlmostThereLastNameHeaderText = document.createElement("p");
    AlmostThereLastNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereLastNameHeaderText.innerHTML = window["LastNameTxt" + window.CurrentCountryID]
    AlmostThereLastNameWrapper.append(AlmostThereLastNameHeaderText);

    let AlmostThereLastNameInputContainer = document.createElement("div");
    AlmostThereLastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AlmostThereLastNameInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereLastNameInputContainer.id = "AlmostThereLastNameInputContainer";
    AlmostThereLastNameWrapper.append(AlmostThereLastNameInputContainer);

    let AlmostThereLastNameInputField = document.createElement("input");
    AlmostThereLastNameInputField.type = "text";
    AlmostThereLastNameInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereLastNameInputField.placeholder = window["InputLastNamePlaceholder" + window.CurrentCountryID]
    AlmostThereLastNameInputField.id = "AlmostThereLastNameInputField";
    AlmostThereLastNameInputContainer.append(AlmostThereLastNameInputField);

    let AlmostThereLastNameWarningText = document.createElement("p");
    AlmostThereLastNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereLastNameWarningText.id = "AlmostThereLastNameWarningText";
    AlmostThereLastNameWrapper.append(AlmostThereLastNameWarningText);


    let AlmostThereEmailWrapper = document.createElement("div"); // Email
    AlmostThereEmailWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereEmailWrapper);

    let AlmostThereEmailWrapperHeader = document.createElement("p");
    AlmostThereEmailWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereEmailWrapperHeader.innerHTML = window["EmailTxt" + window.CurrentCountryID];
    AlmostThereEmailWrapper.append(AlmostThereEmailWrapperHeader);

    let AlmostThereEmailInputContainer = document.createElement("div");
    AlmostThereEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
    AlmostThereEmailInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereEmailInputContainer.id = "AlmostThereEmailInputContainer";
    AlmostThereEmailWrapper.append(AlmostThereEmailInputContainer);

    let AlmostThereEmailInputField = document.createElement("input");
    AlmostThereEmailInputField.type = "email";
    AlmostThereEmailInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereEmailInputField.placeholder = window["SampleEmailPlaceholder" + window.CurrentCountryID];
    AlmostThereEmailInputField.id = "AlmostThereEmailInputField";
    AlmostThereEmailInputField.readOnly = true;
    AlmostThereEmailInputField.value = EmailGet;
    AlmostThereEmailInputContainer.append(AlmostThereEmailInputField);

    let AlmostThereEmailWarningText = document.createElement("p");
    AlmostThereEmailWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereEmailWarningText.id = "AlmostThereEmailWarningText";
    AlmostThereEmailWrapper.append(AlmostThereEmailWarningText);


    let AlmostThereGenderWrapper = document.createElement("div"); // Gender
    AlmostThereGenderWrapper.className = "InputFieldMargin BasicHeaderAndInputWrapper";
    AlmostThereGenderWrapper.style.marginTop = 0;
    AlmostThereStepsWrapper.append(AlmostThereGenderWrapper);

    let AlmostThereGenderWrapperHeader = document.createElement("p");
    AlmostThereGenderWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereGenderWrapperHeader.innerHTML = window["GenderHeaderTxt" + window.CurrentCountryID];
    AlmostThereGenderWrapper.append(AlmostThereGenderWrapperHeader);

    let AlmostThereGenderFlexWrapper = document.createElement("div");
    AlmostThereGenderFlexWrapper.style = "display: flex; flex-direction: row;";
    AlmostThereGenderFlexWrapper.id = "AlmostThereGenderFlexWrapper";
    AlmostThereGenderWrapper.append(AlmostThereGenderFlexWrapper);

    let AlmostThereGenderMaleCheckBoxMargin = document.createElement("div");
    AlmostThereGenderMaleCheckBoxMargin.className = "CheckBoxMarginBasic";
    AlmostThereGenderFlexWrapper.append(AlmostThereGenderMaleCheckBoxMargin);

    let AlmostThereGenderMaleCheckBoxLabel = document.createElement("label");
    AlmostThereGenderMaleCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereGenderMaleCheckBoxMargin.append(AlmostThereGenderMaleCheckBoxLabel);

    let AlmostThereGenderMaleCheckBoxInput = document.createElement("input");
    AlmostThereGenderMaleCheckBoxInput.type = "radio";
    AlmostThereGenderMaleCheckBoxInput.className = "FilterCheckBox Selectable";
    AlmostThereGenderMaleCheckBoxInput.name = "GenderAlmostDone";
    AlmostThereGenderMaleCheckBoxInput.value = "Male";
    AlmostThereGenderMaleCheckBoxInput.checked = true;
    AlmostThereGenderMaleCheckBoxLabel.append(AlmostThereGenderMaleCheckBoxInput);

    let AlmostThereGenderMaleCheckBoxSpan = document.createElement("span");
    AlmostThereGenderMaleCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereGenderMaleCheckBoxLabel.append(AlmostThereGenderMaleCheckBoxSpan);

    let AlmostThereGenderMaleCheckBoxText = document.createElement("p");
    AlmostThereGenderMaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    AlmostThereGenderMaleCheckBoxText.innerHTML = window["GenderMaleTxt" + window.CurrentCountryID];
    AlmostThereGenderMaleCheckBoxMargin.append(AlmostThereGenderMaleCheckBoxText);


    let AlmostThereGenderFemaleCheckBoxMargin = document.createElement("div");
    AlmostThereGenderFemaleCheckBoxMargin.className = "CheckBoxMarginBasic";
    AlmostThereGenderFlexWrapper.append(AlmostThereGenderFemaleCheckBoxMargin);

    let AlmostThereGenderFemaleCheckBoxLabel = document.createElement("label");
    AlmostThereGenderFemaleCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereGenderFemaleCheckBoxMargin.append(AlmostThereGenderFemaleCheckBoxLabel);

    let AlmostThereGenderFemaleCheckBoxInput = document.createElement("input");
    AlmostThereGenderFemaleCheckBoxInput.type = "radio";
    AlmostThereGenderFemaleCheckBoxInput.className = "FilterCheckBox Selectable";
    AlmostThereGenderFemaleCheckBoxInput.name = "GenderAlmostDone";
    AlmostThereGenderFemaleCheckBoxInput.value = "Female";
    AlmostThereGenderFemaleCheckBoxLabel.append(AlmostThereGenderFemaleCheckBoxInput);

    let AlmostThereGenderFemaleCheckBoxSpan = document.createElement("span");
    AlmostThereGenderFemaleCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereGenderFemaleCheckBoxLabel.append(AlmostThereGenderFemaleCheckBoxSpan);

    let AlmostThereGenderFemaleCheckBoxText = document.createElement("p");
    AlmostThereGenderFemaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    AlmostThereGenderFemaleCheckBoxText.innerHTML = window["GenderFemaleTxt" + window.CurrentCountryID];
    AlmostThereGenderFemaleCheckBoxMargin.append(AlmostThereGenderFemaleCheckBoxText);



    let AlmostTherePhoneNumberWrapper = document.createElement("div"); // Phone Number
    AlmostTherePhoneNumberWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostTherePhoneNumberWrapper);

    let AlmostTherePhoneNumberWrapperHeader = document.createElement("p");
    AlmostTherePhoneNumberWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostTherePhoneNumberWrapperHeader.innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberWrapperHeader);

    let AlmostTherePhoneNumberInputContainer = document.createElement("div");
    AlmostTherePhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
    AlmostTherePhoneNumberInputContainer.id = "AlmostTherePhoneNumberInputContainer";
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberInputContainer);

    let AlmostTherePhoneNumberCodeContainer = document.createElement("div");
    AlmostTherePhoneNumberCodeContainer.className = "FirstNumberPhoneNumberWrapper";
    AlmostTherePhoneNumberCodeContainer.id = "AlmostTherePhoneNumberCodeContainer";
    AlmostTherePhoneNumberCodeContainer.setAttribute("country-code", 62);
    AlmostTherePhoneNumberInputContainer.append(AlmostTherePhoneNumberCodeContainer);

    let PhoneCodeNumberTextWrapper = document.createElement("div");
    PhoneCodeNumberTextWrapper.className = "PhoneCodeNumberTextWrapper Selectable3";
    AlmostTherePhoneNumberCodeContainer.append(PhoneCodeNumberTextWrapper);

    let AlmostTherePhoneNumberCodeText = document.createElement("p");
    AlmostTherePhoneNumberCodeText.className = "InterMediumTextFont";
    AlmostTherePhoneNumberCodeText.innerHTML = "+62";
    PhoneCodeNumberTextWrapper.append(AlmostTherePhoneNumberCodeText);


    let AlmostTherePhoneNumberInputField = document.createElement("input");
    AlmostTherePhoneNumberInputField.type = "number";
    AlmostTherePhoneNumberInputField.className = "InputFieldInsideSmallPanel InputFieldWithButton Selectable3 InterMediumTextFont";
    AlmostTherePhoneNumberInputField.placeholder = "12345678";
    AlmostTherePhoneNumberInputField.id = "AlmostTherePhoneNumberInputField";
    AlmostTherePhoneNumberInputField.setAttribute("previous-input", '');
    AlmostTherePhoneNumberInputField.setAttribute("is-change", false);
    AlmostTherePhoneNumberInputContainer.append(AlmostTherePhoneNumberInputField);

    let AlmostTherePhoneNumberWarningText = document.createElement("p");
    AlmostTherePhoneNumberWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostTherePhoneNumberWarningText.id = "AlmostTherePhoneNumberWarningText";
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberWarningText);


    let AlmostThereCountryWrapper = document.createElement("div"); // Country --------------
    AlmostThereCountryWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereCountryWrapper);

    let AlmostThereCountryHeaderText = document.createElement("p");
    AlmostThereCountryHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereCountryHeaderText.innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];
    AlmostThereCountryWrapper.append(AlmostThereCountryHeaderText);

    let AlmostThereCountryDropDownContainer = document.createElement("div");
    AlmostThereCountryDropDownContainer.className = "SmallPanelDropDownContainer";
    AlmostThereCountryDropDownContainer.id = "AlmostThereCountryDropDownContainer";
    AlmostThereCountryDropDownContainer.setAttribute("country-selected", "Indonesia");
    AlmostThereCountryDropDownContainer.setAttribute("original-country", "");
    AlmostThereCountryWrapper.append(AlmostThereCountryDropDownContainer);

    let AlmostThereCountryDropDownWrapper = document.createElement("div");
    AlmostThereCountryDropDownWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont";
    AlmostThereCountryDropDownContainer.append(AlmostThereCountryDropDownWrapper);

    let AlmostThereCountryIcon = document.createElement("img");
    AlmostThereCountryIcon.className = "CircleInsideInputField";
    AlmostThereCountryIcon.src = "/Assets/images/CountryCode/Indonesia.svg";
    AlmostThereCountryIcon.id = "AlmostThereCountryIcon";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryIcon);

    let AlmostThereCountryText = document.createElement("p");
    AlmostThereCountryText.id = "AlmostThereCountryText";
    AlmostThereCountryText.innerHTML = "Indonesia";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryText);

    let AlmostThereCountryChevron = document.createElement("img");
    AlmostThereCountryChevron.className = "ChevronInsideInput ToggleArrow";
    AlmostThereCountryChevron.id = "AlmostThereCountryChevron";
    AlmostThereCountryChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    AlmostThereCountryChevron.style.rotate = "0deg";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryChevron);


    let AlmostThereIDCardWrapper = document.createElement("div"); // ID Card (Optional)
    AlmostThereIDCardWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereIDCardWrapper);

    let AlmostThereIDCardHeaderWrapper = document.createElement("div");
    AlmostThereIDCardHeaderWrapper.className = "HeaderTextWithRadioButtonWrapper";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardHeaderWrapper);

    let AlmostThereIDCardCheckBoxLabel = document.createElement("label");
    AlmostThereIDCardCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereIDCardHeaderWrapper.append(AlmostThereIDCardCheckBoxLabel);

    let AlmostThereIDCardCheckBox = document.createElement("input");
    AlmostThereIDCardCheckBox.className = "FilterCheckBox Selectable";
    AlmostThereIDCardCheckBox.type = "checkbox";
    AlmostThereIDCardCheckBox.id = "AlmostThereIDCardCheckBox";
    AlmostThereIDCardCheckBoxLabel.append(AlmostThereIDCardCheckBox);

    let AlmostThereIDCardCheckBoxSpan = document.createElement("span");
    AlmostThereIDCardCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereIDCardCheckBoxLabel.append(AlmostThereIDCardCheckBoxSpan);

    let AlmostThereIDCardWrapperHeader = document.createElement("p");
    AlmostThereIDCardWrapperHeader.className = "CheckBoxText InterMediumTextFont";
    AlmostThereIDCardWrapperHeader.innerHTML = window["IDCardHeaderTxt" + window.CurrentCountryID];
    AlmostThereIDCardHeaderWrapper.append(AlmostThereIDCardWrapperHeader);

    let AlmostThereIDCardInputFieldContainer = document.createElement("div");
    AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldContainerInvalid";
    AlmostThereIDCardInputFieldContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereIDCardInputFieldContainer.id = "AlmostThereIDCardInputFieldContainer";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardInputFieldContainer);

    let AlmostThereIDCardInputField = document.createElement("input");
    AlmostThereIDCardInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereIDCardInputField.type = "text";
    AlmostThereIDCardInputField.placeholder = window["IDCardInputPlaceholder" + window.CurrentCountryID];
    AlmostThereIDCardInputField.id = "AlmostThereIDCardInputField";
    AlmostThereIDCardInputFieldContainer.append(AlmostThereIDCardInputField);


    let AlmostThereIDCardWarningText = document.createElement("p");
    AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereIDCardWarningText.id = "AlmostThereIDCardWarningText";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardWarningText);


    let AlmostThereReferralIDWrapper = document.createElement("div"); // Referral ID
    AlmostThereReferralIDWrapper.className = "ReferralInputAndButtonContainer";
    AlmostThereStepsWrapper.append(AlmostThereReferralIDWrapper);

    let ReferralWrapperTopSection = document.createElement("div");
    ReferralWrapperTopSection.className = "ReferralWrapperTopSection BasicRoundRadius";
    AlmostThereReferralIDWrapper.append(ReferralWrapperTopSection);

    let ReferralHeaderText = document.createElement("p");
    ReferralHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    ReferralHeaderText.innerHTML = window["PunyaKodeRefHeaderTxt" + window.CurrentCountryID];
    ReferralHeaderText.style="color: #FFFFFF;";
    ReferralWrapperTopSection.append(ReferralHeaderText);

    let RefInputAndButtonWrapper = document.createElement("div");
    RefInputAndButtonWrapper.style = "width: auto; display: flex;";
    ReferralWrapperTopSection.append(RefInputAndButtonWrapper);

    let ReferralMyProfileContainer = document.createElement("div");
    ReferralMyProfileContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    ReferralMyProfileContainer.style.flex = 1;
    ReferralMyProfileContainer.style.marginBottom = 0;
    ReferralMyProfileContainer.style.marginRight = 0;
    ReferralMyProfileContainer.id = "AlmostThereReferralIDContainer";
    RefInputAndButtonWrapper.append(ReferralMyProfileContainer);

    let ReferralMyProfileInput = document.createElement("input");
    ReferralMyProfileInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    ReferralMyProfileInput.id = "AlmostThereReferralIDInputField";
    ReferralMyProfileInput.placeholder = window["InputReferralCodePlaceholderTxt2" + window.CurrentCountryID];
    ReferralMyProfileContainer.append(ReferralMyProfileInput);

    // let CheckReferralAlmostThereButton = document.createElement("button");
    // CheckReferralAlmostThereButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop ButtonUnselectable";
    // CheckReferralAlmostThereButton.id = "CheckReferralAlmostThereButton";
    // RefInputAndButtonWrapper.append(CheckReferralAlmostThereButton);

    // let CheckReferralAlmostThereButtonWrapper = document.createElement("div");
    // CheckReferralAlmostThereButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto 0;";
    // CheckReferralAlmostThereButton.append(CheckReferralAlmostThereButtonWrapper);

    // let CheckReferralAlmostThereButtonIcon = document.createElement("img");
    // CheckReferralAlmostThereButtonIcon.className = "BasicIconInsideButton2 AddReferralIcon";
    // CheckReferralAlmostThereButtonIcon.style.marginLeft = 0;
    // CheckReferralAlmostThereButtonWrapper.append(CheckReferralAlmostThereButtonIcon);

    // let CheckReferralAlmostThereButtonText = document.createElement("p");
    // CheckReferralAlmostThereButtonText.id = "CheckReferralAlmostThereButtonText";
    // CheckReferralAlmostThereButtonText.innerHTML = window["AddReferralBtnTxt" + window.CurrentCountryID];
    // CheckReferralAlmostThereButtonWrapper.append(CheckReferralAlmostThereButtonText);

    let ReferralWrapperBottomSection = document.createElement("div");
    ReferralWrapperBottomSection.className = "ReferralWrapperBottomSection BasicRoundRadius";
    AlmostThereReferralIDWrapper.append(ReferralWrapperBottomSection);

    let RefPrizeIconMyProfile = document.createElement("img");
    RefPrizeIconMyProfile.className = "RefPrizeIconMyProfile";
    RefPrizeIconMyProfile.style = "margin-left: 0; margin-top: auto; margin-bottom: auto;";
    RefPrizeIconMyProfile.src = "/Assets/images/Icon/gift-box-login-sekarang.svg";
    ReferralWrapperBottomSection.append(RefPrizeIconMyProfile);

    let RefBottomMessage = document.createElement("p");
    RefBottomMessage.className = "InputFieldHeaderText InterMediumTextFont";
    RefBottomMessage.style = "color: #FFFFFF; margin: auto 0;";
    RefBottomMessage.innerHTML = window["GetDiscountMessageRefBottomTxt" + window.CurrentCountryID];
    ReferralWrapperBottomSection.append(RefBottomMessage);

    let AlmostThereReferralIDWarningText = document.createElement("p");
    AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereReferralIDWarningText.id = "AlmostThereReferralIDWarningText";
    AlmostThereReferralIDWarningText.innerHTML = "Referral Cannot be Empty!";
    AlmostThereReferralIDWrapper.append(AlmostThereReferralIDWarningText);

    // let AlmostThereReferralIDWrapper = document.createElement("div"); // Referral ID
    // AlmostThereReferralIDWrapper.className = "InputFieldMargin";
    // AlmostThereStepsWrapper.append(AlmostThereReferralIDWrapper);

    // let AlmostThereReferralIDHeader = document.createElement("p");
    // AlmostThereReferralIDHeader.className = "InputFieldHeaderText InterMediumTextFont";
    // AlmostThereReferralIDHeader.innerHTML = window["ReferralID" + window.CurrentCountryID] + " <span class='InterItalicTextFont'>(" + window["OptionalTxt" + window.CurrentCountryID] + ")</span>";
    // AlmostThereReferralIDWrapper.append(AlmostThereReferralIDHeader);

    // let AlmostThereReferralIDContainer = document.createElement("div");
    // AlmostThereReferralIDContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    // AlmostThereReferralIDContainer.style = "width: 100%; min-width: 100%;";
    // AlmostThereReferralIDContainer.id = "AlmostThereReferralIDContainer";
    // AlmostThereReferralIDWrapper.append(AlmostThereReferralIDContainer);

    // let AlmostThereReferralIDInputField = document.createElement("input");
    // AlmostThereReferralIDInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    // AlmostThereReferralIDInputField.type = "text";
    // AlmostThereReferralIDInputField.placeholder = window["ReferralIDInputPlaceholder" + window.CurrentCountryID];
    // AlmostThereReferralIDInputField.id = "AlmostThereReferralIDInputField";
    // AlmostThereReferralIDContainer.append(AlmostThereReferralIDInputField);

    // let AlmostThereReferralIDWarningText = document.createElement("p");
    // AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    // AlmostThereReferralIDWarningText.id = "AlmostThereReferralIDWarningText";
    // AlmostThereReferralIDWrapper.append(AlmostThereReferralIDWarningText);


    let FinalWarningAlmostThere = document.createElement("div"); // Final Warning
    FinalWarningAlmostThere.className = "InputFieldMargin";
    FinalWarningAlmostThere.id = "FinalWarningAlmostThere";
    FinalWarningAlmostThere.style.display = "none";
    FinalWarningAlmostThere.style.marginTop = "0 !important";
    AlmostThereStepsWrapper.append(FinalWarningAlmostThere);

    let RedWarningAlmostThere = document.createElement("div");
    RedWarningAlmostThere.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer";
    RedWarningAlmostThere.id = "RedWarningAlmostThere";
    FinalWarningAlmostThere.append(RedWarningAlmostThere);

    let RedWarningAlmostThereText = document.createElement("p");
    RedWarningAlmostThereText.className = "InterMediumTextFont";
    RedWarningAlmostThereText.id = "RedWarningAlmostThereText";
    RedWarningAlmostThereText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
    RedWarningAlmostThere.append(RedWarningAlmostThereText);


    let TwoButtonAlmostThereWrapper = document.createElement("div"); // Set Up Later Continue Button
    TwoButtonAlmostThereWrapper.className = "MoreThanOneButtonFlexWrapper InputFieldMarginBoth";
    TwoButtonAlmostThereWrapper.style = "margin-left: auto; margin-right: auto;";
    AlmostThereStepsWrapper.append(TwoButtonAlmostThereWrapper);

    let AlmostThereSetUpLaterButton = document.createElement("button");
    AlmostThereSetUpLaterButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight PaddingExtendedButton Selectable";
    AlmostThereSetUpLaterButton.id = "AlmostThereSetUpLaterButton";
    AlmostThereSetUpLaterButton.innerHTML = window["SetuplaterText" + window.CurrentCountryID];
    TwoButtonAlmostThereWrapper.append(AlmostThereSetUpLaterButton);

    let AlmostThereContinueButton = document.createElement("button");
    AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
    AlmostThereContinueButton.innerHTML = window["ContinueTxt" + window.CurrentCountryID];
    AlmostThereContinueButton.id = "AlmostThereContinueButton";
    TwoButtonAlmostThereWrapper.append(AlmostThereContinueButton);

    let TermsAndConditionAlmostThere = document.createElement("p"); // Terms & Condition ----
    TermsAndConditionAlmostThere.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionAlmostThere.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionAlmostThere.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(TermsAndConditionAlmostThere);


    // ------------------------------------------- ADD FUNCTION 2 (INPUT PROFILE) ------------------------------------------- 
    
    // Close --------------------------------------------------------
    AlmostThereCloseButton.onclick = function()
    {
        window.location.reload();
    }

    // First Name --------------------------------------------------------
    AlmostThereFirstNameInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereFirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereFirstNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereFirstNameInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });
    
    // Last Name --------------------------------------------------------
    AlmostThereLastNameInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereLastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereLastNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereLastNameInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });

    // Email --------------------------------------------------------
    AlmostThereEmailInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereEmailWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereEmailInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });

    // Country --------------------------------------------------------
    AlmostThereCountryDropDownContainer.onclick = function()
    {
        window.OpenCountryChoice(AlmostThereCountryDropDownContainer, AlmostThereCountryIcon, AlmostThereCountryText, "AlmostThereCountryChevron", "AlmostThere", ()=> window.CheckInputtedAlmostThere(2, true, EmailGet));
    }

    // ID Card --------------------------------------------------------
    AlmostThereIDCardInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereIDCardInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });

    // Referral ID --------------------------------------------------------
    // AlmostThereReferralIDInputField.onfocus = function(event)
    // {
    //     AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
    //     AlmostThereReferralIDContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    //     AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    // }
    // AlmostThereReferralIDInputField.addEventListener("focusout", (event) =>
    // {
    //     window.CheckInputtedAlmostThere(2, true, IdUser, EmailGet);
    // });

    ReferralMyProfileInput.onfocus = function(event)
    {
        ReferralMyProfileContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    ReferralMyProfileInput.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });

    // Gender ---------------------------------------------------
    AlmostThereGenderMaleCheckBoxInput.onclick = function()
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    }
    
    AlmostThereGenderFemaleCheckBoxInput.onclick = function()
    {
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    }
    
    // Phone Number ---------------------------------------------------
    AlmostTherePhoneNumberCodeContainer.onclick = function()
    {
        window.OpenCountryCode(AlmostTherePhoneNumberCodeContainer, AlmostTherePhoneNumberCodeText, 'AlmostThere', window.CheckInputtedAlmostThere(2, true, EmailGet));
    }

    AlmostTherePhoneNumberInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostTherePhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
        AlmostTherePhoneNumberWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostTherePhoneNumberInputField.addEventListener("focusout", (event) =>
    {
        if(AlmostTherePhoneNumberInputField.getAttribute("previous-input") != AlmostTherePhoneNumberInputField.value)
        {
            AlmostTherePhoneNumberInputField.setAttribute("previous-input", AlmostTherePhoneNumberInputField.value);
            AlmostTherePhoneNumberInputField.setAttribute("is-change", 'true');
        }
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    });

    // ID Card --------------------------------------------------------
    AlmostThereIDCardCheckBox.onchange = function()
    {
        if(AlmostThereIDCardCheckBox.checked == true)
        {
            AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        }
        else
        {
            AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
            AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldContainerInvalid";
        }
        window.CheckInputtedAlmostThere(2, true, EmailGet);
    }

    // Set Up & Continue Button --------------------------------------------------------

    AlmostThereSetUpLaterButton.onclick = function()
    {
        window.location.reload();
    }

    AlmostThereContinueButton.onclick = function()
    {
        let PushNewUserInfoBlocker = window.InstantiateLoadingBlocker("PushNewUserInfoBlocker");
        window.PushNewUserInfoAlmostThere(EmailGet, PushNewUserInfoBlocker, ()=> window.MovePanelInsideContainerNext(AlmostThereStepsWrapper, YourAccountSuccessWrapper, FlexFullDisplayPanel, function(){PushNewUserInfoBlocker.remove()}));
    }

    // ====================================== SUCCESS ======================================

    let YourAccountSuccessStepsWrapperFlex = document.createElement("div");
    YourAccountSuccessStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    YourAccountSuccessWrapper.append(YourAccountSuccessStepsWrapperFlex);

    let YourAccountSuccessCloseButton = document.createElement("img");
    YourAccountSuccessCloseButton.className = "CloseButtonInsidePanel Selectable2";
    YourAccountSuccessCloseButton.id = "YourAccountSuccessCloseButton";
    YourAccountSuccessCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    YourAccountSuccessStepsWrapperFlex.append(YourAccountSuccessCloseButton);

    let CheckSuccessGreenCircle = document.createElement("img");
    CheckSuccessGreenCircle.className = "CheckSuccessGreenCircle";
    CheckSuccessGreenCircle.src = "/Assets/images/Icon/check-grey-circle.svg";
    YourAccountSuccessWrapper.append(CheckSuccessGreenCircle);

    let YourAccountSuccessHeader = document.createElement("p");
    YourAccountSuccessHeader.className = "RoomHotelNameInsidePanel MarginTextUpDown InterBoldTextFont";
    YourAccountSuccessHeader.style.marginLeft = "auto";
    YourAccountSuccessHeader.style.marginRight = "auto";
    YourAccountSuccessHeader.style.textAlign = "center";
    YourAccountSuccessHeader.innerHTML = window["AccCreateSuccessWeltoPing" + window.CurrentCountryID];
    YourAccountSuccessWrapper.append(YourAccountSuccessHeader);

    let YourAccountSuccessMessage = document.createElement("p");
    YourAccountSuccessMessage.className = "DescriptionTextNotDisableable DescriptionForgotPassConfirmText MarginTextUpDown InterRegularTextFont";
    YourAccountSuccessMessage.style.color = "rgb(27, 27, 27)";
    YourAccountSuccessMessage.style.marginLeft = "auto";
    YourAccountSuccessMessage.style.marginRight = "auto";
    YourAccountSuccessMessage.style.textAlign = "center";
    YourAccountSuccessMessage.innerHTML = window["AccCreateSuccessMessage" + window.CurrentCountryID];
    YourAccountSuccessWrapper.append(YourAccountSuccessMessage);


    let YourAccountSuccessExploreButton = document.createElement("button");
    YourAccountSuccessExploreButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable InputFieldMarginBoth";
    YourAccountSuccessExploreButton.style = "margin-left: auto; margin-right: auto;";
    YourAccountSuccessExploreButton.innerHTML = window["ExplorePinginGoText" + window.CurrentCountryID];
    YourAccountSuccessExploreButton.id = "YourAccountSuccessExploreButton";
    YourAccountSuccessWrapper.append(YourAccountSuccessExploreButton);


    // ====================================== FUNCTION 3 (SUCCESS) ====================================== 
    
    YourAccountSuccessCloseButton.onclick = function()
    {
        window.location.reload();
    }

    YourAccountSuccessExploreButton.onclick = function()
    {
        window.location.reload();
    }
}


window.CheckInputtedAlmostThere = function(whichstep, allowchange, EmailGet)
{
    let IsInputtedValid = true;

    // ------------------------------ 1st Section -----------------------------------
    let NewPasswordInput = document.getElementById("AlmostThereNewPasswordInputField").value;
    let NewPasswordContainer = document.getElementById("AlmostThereNewPasswordInputContainer");
    let NewPasswordWarning = document.getElementById("AlmostThereNewPasswordWarningText");

    let ConfirmPasswordInput = document.getElementById("AlmostThereConfirmPasswordInputField").value;
    let ConfirmPasswordContainer = document.getElementById("AlmostThereConfirmPasswordInputContainer");
    let ConfirmPasswordWarning = document.getElementById("AlmostThereConfirmPasswordWarningText");

    let NextButtonSection1 = document.getElementById("AlmostThereConfirmPasswordNextButton");

    // ------------------------------ 2nd Section -----------------------------------
    let FirstName = document.getElementById("AlmostThereFirstNameInputField").value;
    let FirstNameContainer = document.getElementById("AlmostThereFirstNameInputContainer");
    let FirstNameWarning = document.getElementById("AlmostThereFirstNameWarningText");

    let LastName = document.getElementById("AlmostThereLastNameInputField").value;
    let LastNameContainer = document.getElementById("AlmostThereLastNameInputContainer");
    let LastNameWarning = document.getElementById("AlmostThereLastNameWarningText");

    let EmailInput = document.getElementById("AlmostThereEmailInputField").value;
    let EmailInputContainer = document.getElementById("AlmostThereEmailInputContainer");
    let EmailWarning = document.getElementById("AlmostThereEmailWarningText");

    let AlmostThereGenderContainer = document.getElementById("AlmostThereGenderFlexWrapper");
    let GenderCheckBoxes = AlmostThereGenderContainer.querySelectorAll('[name="GenderAlmostDone"]');
    let GenderSelected = "";
    GenderCheckBoxes.forEach(CheckBox =>
    {
        if(CheckBox.checked == true)
        {
            GenderSelected = CheckBox.value;
        }
    });

    let PhoneNumberCountryCode = document.getElementById("AlmostTherePhoneNumberCodeContainer").getAttribute("country-code");
    let PhoneNumberInputField = document.getElementById("AlmostTherePhoneNumberInputField");
    let PhoneNumberInput = PhoneNumberInputField.value;
    let PhoneNumberContainer = document.getElementById("AlmostTherePhoneNumberInputContainer");
    let PhoneNumberWarning = document.getElementById("AlmostTherePhoneNumberWarningText");

    let IDCardCheckBox = document.getElementById("AlmostThereIDCardCheckBox");
    let IDCardContainer = document.getElementById("AlmostThereIDCardInputFieldContainer");
    let IDCardInput = document.getElementById("AlmostThereIDCardInputField").value;
    let IDCardWarning = document.getElementById("AlmostThereIDCardWarningText");

    let ReferralContainer = document.getElementById("AlmostThereReferralIDContainer");
    let ReferralInput = document.getElementById("AlmostThereReferralIDInputField").value;
    let ReferralWarning = document.getElementById("AlmostThereReferralIDWarningText");

    let NextButtonSection2 = document.getElementById("AlmostThereContinueButton");

    if(whichstep == 1)
    {
        let IsPasswordCorrect = window.ConfirmTwoPasswordInputCorrect(NewPasswordInput, ConfirmPasswordInput, NewPasswordContainer, ConfirmPasswordContainer, NewPasswordWarning, ConfirmPasswordWarning, allowchange);

        if(IsPasswordCorrect == false)
        {
            NextButtonSection1.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        }
        else
        {
            NextButtonSection1.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        }
    }
    else if(whichstep == 2)
    {
        if(FirstName == ""  || FirstName.replace(/ /g, "") == "") // First Name
        {
            IsInputtedValid = false;

            FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";

            FirstNameWarning.className = "RedWarningText InterMediumTextFont";
            FirstNameWarning.innerHTML = window["FirstNameCannotEmpty" + window.CurrentCountryID];
        }

        if(PhoneNumberInput == ""  || PhoneNumberInput.replace(/ /g, "") == "") // Email
        {
            IsInputtedValid = false;
            
            PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";

            PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
            PhoneNumberWarning.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
        else if(PhoneNumberInputField.getAttribute("is-change") == 'true')
        {
            window.CheckPhoneNumberAlreadyUsed(null, PhoneNumberCountryCode, PhoneNumberInputField, false, function(result, reasoninvalid)
            {
                PhoneNumberInputField.setAttribute("is-change", 'false');

                if(result == false)
                {
                    IsInputtedValid = false;
                    PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
                    PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
                    PhoneNumberWarning.innerHTML = window["PhoneNumberInvalidTxt" + window.CurrentCountryID];
                    if(reasoninvalid == "Already Used")
                    {
                        PhoneNumberWarning.innerHTML = window["PhoneNumberAlreadyUsedTxt" + window.CurrentCountryID];
                    }
                    NextButtonSection2.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
                }
            });
        }

        if(IDCardCheckBox.checked == true) // First Name
        {
            if(IDCardInput == ""  || IDCardInput.replace(/ /g, "") == "")
            {
                IsInputtedValid = false;

                IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";

                IDCardWarning.className = "RedWarningText InterMediumTextFont";
                IDCardWarning.innerHTML = window["IDCardCannotEmpty" + window.CurrentCountryID];
            }
            else
            {
                window.CheckIDCardUsed(null, IDCardInput, false, function(result)
                {
                    if(result == false)
                    {
                        IsInputtedValid = false;
                        IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                        IDCardWarning.className = "RedWarningText InterMediumTextFont";
                        IDCardWarning.innerHTML = window["IDCardCannotBeUsed" + window.CurrentCountryID];
                        NextButtonSection2.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
                    }
                });
            }
        }

        if(ReferralInput != ""  || ReferralInput.replace(/ /g, "") !="")
        {
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // window.CheckReferralIDExist(ReferralInput, IdUser, function(result)
            // {
            //     if(result != true)
            //     {
            //         IsInputtedValid = false;
            //         ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            //         ReferralWarning.className = "RedWarningText InterMediumTextFont";
            //         ReferralWarning.innerHTML = window.DetermineErrorReferralTxt(result);
            //         NextButtonSection2.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
            //     }
            // });
        }

        if(IsInputtedValid == false)
        {
            NextButtonSection2.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        }
        else
        {
            NextButtonSection2.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        }
    }
}


// ====================================== PUSH PASSWORD AND USER INFO =======================================

window.PushNewUserPassword = async function(PushPasswordBlocker, FlexFullDisplayPanel, createpasswordwrapper, emailget, NewPasswordInputField, functiontocallafter)
{
    let URLNewPassword = "/v2/email/new-password";
    let NewPasswordInput = NewPasswordInputField.value;

    let formData = new FormData();
    formData.append('email', emailget);
    formData.append('new_password', NewPasswordInput);
    formData.append('password', NewPasswordInput);
    formData.append('lang', window.CurrentCountryID);
    await window.getBrowserData(formData);

    //console.log(URLNewPassword);
    //console.log(window.ConvertFormDataToJSON(formData));

    // Push The Password --------------------------------------------------------

    window.CallApiAxios({ 
        method: "POST",
        url: URLNewPassword,
        data: formData
    }).then(res =>
    {
        //console.log(URLNewPassword);
        //console.log(res);

        if(res.status == 200)
        {
            let PushPasswordData = res.data;
            //console.log(PushPasswordData);

            window.ImmediateLoginEmailandPassword(formData, null, null, null, ()=>functiontocallafter());
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PasswordGagalTersimpanTxt" + window.CurrentCountryID]);
            PushPasswordBlocker.remove();
        }
    })
    .catch(err =>
    {
        //console.error(err);
        let ErrorData = err.data;

        if(ErrorData.message != "An unexpected error occurred while processing the request" &&ErrorData.message != "Validation failed")
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.StatusSavePasswordTxt(ErrorData.message));

            if(ErrorData.message == "Verification has expired. Please request a new verification email." || ErrorData.message == "Email has not been verified") // If Expired Then Send New Verification ========================
            {
                InstantiateTempEmailSendVerifPanel(FlexFullDisplayPanel, createpasswordwrapper, emailget);
            }
        }
        else if(ErrorData.errors != null && (ErrorData.errors.email != null || ErrorData.errors.new_password != null))
        {
            if(ErrorData.errors.email != null)
            {
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.StatusSavePasswordTxt(ErrorData.errors.email[0]));
            }
            else
            {
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.StatusSavePasswordTxt(ErrorData.errors.new_password[0]));
            }
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PasswordGagalTersimpanTxt" + window.CurrentCountryID]);
        }
        PushPasswordBlocker.remove();
    });
}


window.PushNewUserInfoAlmostThere = async function(EmailGet, PushNewUserInfoBlocker, functiontocallafter)
{
    // Names ------------------------------------------------------------------------------------------------------------
    let FirstNameInput = document.getElementById("AlmostThereFirstNameInputField").value;
    let LastNameInput = document.getElementById("AlmostThereLastNameInputField").value;

    // Gender ------------------------------------------------------------------------------------------------------------
    let AlmostThereGenderContainer = document.getElementById("AlmostThereGenderFlexWrapper");
    let GenderCheckBoxes = AlmostThereGenderContainer.querySelectorAll('[name="GenderAlmostDone"]');
    let Genderinput = "";
    GenderCheckBoxes.forEach(CheckBox =>
    {
        if(CheckBox.checked == true)
        {
            Genderinput = CheckBox.value;
        }
    });

    // Country Code and Phone Number ------------------------------------------------------------------------------------------------------------
    let CountryCode = document.getElementById("AlmostTherePhoneNumberCodeContainer").getAttribute("country-code");

    let PhoneNumberInput = document.getElementById("AlmostTherePhoneNumberInputField").value;
    // let PhoneNumberContainer = document.getElementById("AlmostTherePhoneNumberInputContainer");
    // let PhoneNumberWarning = document.getElementById("AlmostTherePhoneNumberWarningText");

    // Email ------------------------------------------------------------------------------------------------------------
    let EmailInput = document.getElementById("AlmostThereEmailInputField").value;
    // let EmailInputContainer = document.getElementById("AlmostThereEmailInputContainer");
    // let EmailWarning = document.getElementById("AlmostThereEmailWarningText");

    if(EmailGet == "")
    {
        EmailGet = EmailInput;
    }

    // Country ------------------------------------------------------------------------------------------------------------
    let CountryInput = document.getElementById("AlmostThereCountryDropDownContainer").getAttribute("country-selected");

    // ID Card ------------------------------------------------------------------------------------------------------------
    let IDCardInput = document.getElementById("AlmostThereIDCardInputField").value;

    // Referral ------------------------------------------------------------------------------------------------------------
    let ReferralInput = document.getElementById("AlmostThereReferralIDInputField").value;

    // Which Warning ------------------------------------------------------------------------------------------------------------
    let FinalWarningWrapper = document.getElementById("FinalWarningAlmostThere");
    let FinalWarningText = document.getElementById("RedWarningAlmostThereText");
    
    let formData = new FormData();
    formData.append('first_name', FirstNameInput);
    formData.append('last_name', LastNameInput);
    formData.append('gender', Genderinput);
    formData.append('country_code', CountryCode);
    formData.append('phone_number', PhoneNumberInput);
    formData.append("country", CountryInput);
    formData.append('id_card', IDCardInput);
    await window.getBrowserData(formData);
    formData.append('lang', window.CurrentCountryID);
    formData.append('userID ', window.CurrentUserID);
    formData.append('token', window.CurrentUserToken);
    formData.append('id_referral', ReferralInput);
    //console.log(window.ConvertFormDataToJSON(formData));


    // Prepare Function On Error ------------------------------------------------------------------------------
    let functiononerror = function()
    {
        PushNewUserInfoBlocker.remove();
        FinalWarningWrapper.style.display = "";
    }

    let functionreloaduserifsuccess = function()
    {
        if(sessionStorage.getItem("IM_Ping_INFO") != null)
            sessionStorage.removeItem("IM_Ping_INFO");

        if(sessionStorage.getItem("U_Ping_INFO") != null)
            sessionStorage.removeItem("U_Ping_INFO");

        window.CheckUserInfoExist(true);
    }

    if(ReferralInput != null && ReferralInput.replace(/ /g, "") !="")
    {
        window.UpdateReferralOnly(formData, window.CurrentUserID, FinalWarningText, ()=>
        {
            window.UpdateUserProfile(window.CurrentUserID, formData, FinalWarningWrapper, FinalWarningText, ()=>
            {
                functionreloaduserifsuccess();
                functiontocallafter();
            }, ()=>functiononerror());

        }, ()=>functiononerror());
    }
    else
    {
        window.UpdateUserProfile(window.CurrentUserID, formData, FinalWarningWrapper, FinalWarningText, ()=>
        {
            functionreloaduserifsuccess();
            functiontocallafter();
        }, ()=>functiononerror());
    }
}


function InstantiateTempEmailSendVerifPanel(wheretoInstantiate, createpasswordwrapper, emailget)
{
    let EmailConfirmationStepsWrapper = document.createElement("div");
    EmailConfirmationStepsWrapper.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    EmailConfirmationStepsWrapper.id = "EmailConfirmationStepsWrapper";
    EmailConfirmationStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    wheretoInstantiate.append(EmailConfirmationStepsWrapper);

    let EmailConfirmationStepsWrapperFlex = document.createElement("div");
    EmailConfirmationStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    EmailConfirmationStepsWrapper.append(EmailConfirmationStepsWrapperFlex);

    let EmailConfirmationCloseButton = document.createElement("img");
    EmailConfirmationCloseButton.className = "CloseButtonInsidePanel Selectable2";
    EmailConfirmationCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    EmailConfirmationCloseButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        window.RemoveTimerAndVisibility(true);
        window.MovePanelInsideContainerBack(EmailConfirmationStepsWrapper, createpasswordwrapper, wheretoInstantiate, ()=>
        {
            EmailConfirmationStepsWrapper.remove();
        })
    }
    EmailConfirmationStepsWrapperFlex.append(EmailConfirmationCloseButton);


    let EmailConfirmationIcon = document.createElement("img");
    EmailConfirmationIcon.className = "EmailConfirmationIcon";
    EmailConfirmationIcon.src = "/Assets/images/Icon/email-confirmation-icon.svg";
    EmailConfirmationStepsWrapper.append(EmailConfirmationIcon);

    let EmailConfirmationHeaderText = document.createElement("p");
    EmailConfirmationHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    EmailConfirmationHeaderText.style = "width: fit-content; margin: 0 auto;";
    EmailConfirmationHeaderText.innerHTML = window["EmailConfirmationTxt" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(EmailConfirmationHeaderText);

    let EmailConfirmationMessageText = document.createElement("p");
    EmailConfirmationMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    EmailConfirmationMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    EmailConfirmationMessageText.innerHTML = window.WeHaveSentEmailValidTxt(window.CurrentCountryID, emailget);
    EmailConfirmationStepsWrapper.append(EmailConfirmationMessageText);

    let EmailConfirmationIfyounotgotanemailText = document.createElement("p");
    EmailConfirmationIfyounotgotanemailText.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
    EmailConfirmationIfyounotgotanemailText.style="color: #475467; margin-left: auto; margin-right: auto;";
    EmailConfirmationIfyounotgotanemailText.innerHTML = window["IfYouGotNoEmailTxt" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(EmailConfirmationIfyounotgotanemailText);

    let ResendChangeEmailButtonWrapper = document.createElement("div");
    ResendChangeEmailButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    ResendChangeEmailButtonWrapper.style = "margin-top: 0;";
    EmailConfirmationStepsWrapper.append(ResendChangeEmailButtonWrapper);

    let EmailConfirmationResendEmailButton = document.createElement("button");
    EmailConfirmationResendEmailButton.className = "BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop Selectable";
    EmailConfirmationResendEmailButton.innerHTML = window["ResendEmailBtnTxt" + window.CurrentCountryID];
    EmailConfirmationResendEmailButton.id = "EmailConfirmationResendEmailButton";
    EmailConfirmationResendEmailButton.onclick = function(event)
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        if(EmailConfirmationResendEmailButton.classList.contains("ButtonInvalid") == false)
        {
            window.RemoveTimerAndVisibility(true);
            window.MovePanelInsideContainerBack(EmailConfirmationStepsWrapper, createpasswordwrapper, wheretoInstantiate, ()=>
            {
                EmailConfirmationStepsWrapper.remove();
            })
        }
    }
    ResendChangeEmailButtonWrapper.append(EmailConfirmationResendEmailButton);

    let EmailConfirmationChangeEmailButton = document.createElement("button");
    EmailConfirmationChangeEmailButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
    EmailConfirmationChangeEmailButton.innerHTML = window["ChangeEmailBtnTxt" + window.CurrentCountryID];
    EmailConfirmationChangeEmailButton.onclick = function(event)
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        window.RemoveTimerAndVisibility(true);
        window.MovePanelInsideContainerBack(EmailConfirmationStepsWrapper, createpasswordwrapper, wheretoInstantiate, ()=>
        {
            EmailConfirmationStepsWrapper.remove();
        })
    }
    ResendChangeEmailButtonWrapper.append(EmailConfirmationChangeEmailButton);

    let EmailConfirmationOrangeWrapper = document.createElement("div");
    EmailConfirmationOrangeWrapper.className = "OrangeWarningContainer BasicRoundRadius HideOnMobile";
    EmailConfirmationStepsWrapper.append(EmailConfirmationOrangeWrapper);

    let EmailConfirmationMarginWrapper = document.createElement("div");
    EmailConfirmationMarginWrapper.style = "width: fit-content; height: fit-content; margin: auto; display: flex;";
    EmailConfirmationOrangeWrapper.append(EmailConfirmationMarginWrapper);

    let EmailConfirmationCircleIcon = document.createElement("img");
    EmailConfirmationCircleIcon.className = "WarningCircleIcon";
    EmailConfirmationCircleIcon.src = "/Assets/images/ButtonIcon/warning-circle.svg";
    EmailConfirmationMarginWrapper.append(EmailConfirmationCircleIcon);

    let EmailConfirmationOrangeText = document.createElement("p");
    EmailConfirmationOrangeText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    EmailConfirmationOrangeText.style.margin = "auto 0";
    EmailConfirmationMarginWrapper.append(EmailConfirmationOrangeText);

    let ExpiryTimeDisplayer = window.LinkWillExpiredTxtFunc(EmailConfirmationOrangeText);

    let TermsAndConditionEmailConfirmationSection = document.createElement("p");
    TermsAndConditionEmailConfirmationSection.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionEmailConfirmationSection.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionEmailConfirmationSection.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(TermsAndConditionEmailConfirmationSection);


    let SendVerifBlocker = window.InstantiateLoadingBlocker("SendVerifBlocker");

    SendVerifAgainFunction(SendVerifBlocker, emailget, ExpiryTimeDisplayer, ()=>
    {
        window.MovePanelInsideContainerNext(createpasswordwrapper, EmailConfirmationStepsWrapper, wheretoInstantiate, function ()
        {
            SendVerifBlocker.remove();
        });
    })

}

function SendVerifAgainFunction(sendverifblocker, EmailInputted, ExpiryTimeDisplayer, functiontocall)
{
    (async () =>
    {
        let formData = new FormData();
        formData.append('email', EmailInputted);
        formData.append('lang', window.CurrentCountryID);

        let RequestEmailVerifURL = "/v2/email/request-verif";
        await window.getBrowserData(formData);
        //console.log(window.ConvertFormDataToJSON(formData));

        window.CallApiAxios({
            method: "POST",
            url: RequestEmailVerifURL,
            data: formData,
        })
        .then((res) =>
        {
            //console.log(RequestEmailVerifURL);
            //console.log(res);

            if (res.data.success == true)
            {
                let SendVerifData = res.data;
                //console.log(SendVerifData);

                let DurationText = ExpiryTimeDisplayer;
                window.EndTimeCountDown = window.ConvertThisToDate(SendVerifData.data.best_before, true);
                //console.log(window.EndTimeCountDown);

                let FunctionAfterCountDownEnd = function ()
                {
                    // Function that will Be Called After Countdown Finished
                    document.removeEventListener("visibilitychange", window.VisibilityChangeHandler); // Remove Visibility Change Function
                    document.getElementById("EmailConfirmationResendEmailButton").className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
                };
                window.StartCountDown([DurationText], 1, null, () => FunctionAfterCountDownEnd());

                if(functiontocall != null)
                    functiontocall();
            }
            else
            {
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["BasicErrorMes" + window.CurrentCountryID]);
                sendverifblocker.remove();
            }
        })
        .catch((err) =>
        {
            //console.error(err);
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["BasicErrorMes" + window.CurrentCountryID]);
            sendverifblocker.remove();
        });
    })();
}

// =============================== ADS POP UP ===============================

var SortingBannerData;
var WhichBannerIndex = 0;

function PreparePopUpInfo()
{
    if(sessionStorage.getItem("PopUpDisplayed") == null)
    {
        // ---------------------------------- POP UP BANNER ----------------------------------

        let SortingPopUpBannerURL = "/v2/banners/pop-up";

        window.CallApiAxios({
            method: "GET",
            url: SortingPopUpBannerURL,
        }).then(res =>
        {
            //console.log(SortingPopUpBannerURL);
            
            if(res.status == 200)
            {
                SortingBannerData = res.data.data;
                //console.log(SortingBannerData);

                if(SortingBannerData.length == 0)
                return

                PreparePopUpBannerUI();
            }
        })
        .catch(err =>
        {
            //console.error(err);
        });

        sessionStorage.setItem("PopUpDisplayed", true);
    }
}

function PreparePopUpBannerUI()
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);
            
    let PopUpAdsContainer = document.createElement("div");
    PopUpAdsContainer.className = "PopUpAdsContainer";
    BasicBlackBlocker.append(PopUpAdsContainer);

    let PopUpIndexImageContainer = document.createElement("div");
    PopUpIndexImageContainer.className = "PopUpIndexImageContainer PopUpIndexImageContainerSelectable";
    PopUpAdsContainer.append(PopUpIndexImageContainer);
            
    if(SortingBannerData.length > 1)
    {
        let LeftNavButton = document.createElement("button"); // Prev Button -----------------------------
        LeftNavButton.className = "PopUpNextPrevButton NavButtonFullScreen left";
        LeftNavButton.onclick = function()
        {
            ReduceIncreasePopUpBannerIndex(-1, PopUpIndexImageContainer);
        }
        BasicBlackBlocker.append(LeftNavButton);

        let LeftNavButtonIMG = document.createElement("img");
        LeftNavButtonIMG.src = "/Assets/images/ButtonIcon/NextPrevFSButton.svg";
        LeftNavButton.append(LeftNavButtonIMG);

        let RightNavButton = document.createElement("button"); // Next Button -----------------------------
        RightNavButton.className = "PopUpNextPrevButton NavButtonFullScreen right";
        RightNavButton.onclick = function()
        {
            ReduceIncreasePopUpBannerIndex(1, PopUpIndexImageContainer);
        }
        BasicBlackBlocker.append(RightNavButton);

        let RightNavButtonIMG = document.createElement("img");
        RightNavButtonIMG.src = "/Assets/images/ButtonIcon/NextPrevFSButton.svg";
        RightNavButton.append(RightNavButtonIMG);
    }

    let CloseWhiteBlocker = document.createElement("img"); // Close Button -----------------------------
    CloseWhiteBlocker.className = "PopUpImageButtonClose Selectable2";
    CloseWhiteBlocker.src = "/Assets/images/ButtonIcon/close-white-circle.svg";
    CloseWhiteBlocker.onclick = function()
    {
        window.ClosePanelAnimate(PopUpAdsContainer, BasicBlackBlocker, null);
    }
    BasicBlackBlocker.append(CloseWhiteBlocker);

    DisplayPopUpImage(PopUpIndexImageContainer)

    // ANIMATE =====================================

    window.OpenPanelAnimate(PopUpAdsContainer, BasicBlackBlocker);
}


// Increase Reduce Pop Up Banner ----------------------------------------------

function ReduceIncreasePopUpBannerIndex(whattoaddorreduce, PopUpIndexImageContainer)
{
    if(((WhichBannerIndex + 1) == SortingBannerData.length) && whattoaddorreduce > 0)
    {
        WhichBannerIndex = 0
    }
    else if((WhichBannerIndex == 0) && whattoaddorreduce < 0)
    {
        WhichBannerIndex = ((SortingBannerData.length) - 1)
    }
    else
    {
        WhichBannerIndex = WhichBannerIndex + whattoaddorreduce;
    }

    DisplayPopUpImage(PopUpIndexImageContainer);
}


// Display Pop Up Banner ----------------------------------------------

function DisplayPopUpImage(PopUpIndexImageContainer)
{
    PopUpIndexImageContainer.innerHTML = "";

    // Desktop Image ---------------------------------------------------------------------------------------------

    let PopUpDesktopSizeContainer = document.createElement("div");
    PopUpDesktopSizeContainer.className = "PopUpDesktopSizeContainer";
    PopUpIndexImageContainer.append(PopUpDesktopSizeContainer);
    
    let LoadingPopUpDesktop = document.createElement("div");
    LoadingPopUpDesktop.className = "loading_grey ImageFullCover";
    PopUpDesktopSizeContainer.append(LoadingPopUpDesktop);

    let PopUpIndexImageMainSize = document.createElement("img");
    PopUpIndexImageMainSize.className = "PopUpIndexImageMainSize";
    PopUpIndexImageMainSize.src = "/Assets/images/NoHotelImage.jpg";
    PopUpIndexImageMainSize.style.opacity = 0;
    window.checkImageUrlValid(SortingBannerData[WhichBannerIndex].banner.pop_up_image_desktop, "/Assets/images/NoHotelImage.jpg", PopUpIndexImageMainSize, () =>
    {
        window.CheckIfImageLoadedAndCallAFunction(PopUpDesktopSizeContainer, ()=>
        {
            LoadingPopUpDesktop.remove();
            PopUpIndexImageMainSize.style.opacity = 1;
        });
    }, {});
    PopUpDesktopSizeContainer.append(PopUpIndexImageMainSize);

    // Mobile Image ---------------------------------------------------------------------------------------------

    let PopUpMobileSizeContainer = document.createElement("div");
    PopUpMobileSizeContainer.className = "PopUpMobileSizeContainer";
    PopUpIndexImageContainer.append(PopUpMobileSizeContainer);

    let LoadingPopUpMobile = document.createElement("div");
    LoadingPopUpMobile.className = "loading_grey ImageFullCover";
    PopUpIndexImageContainer.append(LoadingPopUpMobile);
            
    let PopUpIndexImageMobileSize = document.createElement("img");
    PopUpIndexImageMobileSize.className = "PopUpIndexImageMobileSize";
    PopUpIndexImageMobileSize.src = "/Assets/images/NoImageMobile.jpg";
    PopUpIndexImageMobileSize.style.opacity = 0;
    window.checkImageUrlValid(SortingBannerData[WhichBannerIndex].banner.pop_up_image_mobile, "/Assets/images/NoImageMobile.jpg", PopUpIndexImageMobileSize, () =>
    {
        window.CheckIfImageLoadedAndCallAFunction(PopUpDesktopSizeContainer, ()=>
        {
            LoadingPopUpMobile.remove();
            PopUpIndexImageMobileSize.style.opacity = 1;
        });
    }, {});
    PopUpMobileSizeContainer.append(PopUpIndexImageMobileSize);

    if(SortingBannerData[WhichBannerIndex].banner.direct_link == "")
    {
        PopUpIndexImageContainer.className = "PopUpIndexImageContainer";
    }
    else
    {
        PopUpIndexImageContainer.className = "PopUpIndexImageContainer PopUpIndexImageContainerSelectable";

        let HREFInsideContainer = document.createElement("a")
        HREFInsideContainer.className = "HREFInsideContainer"
        HREFInsideContainer.id = "HREFInsideContainer";
        HREFInsideContainer.target = "_blank";
        HREFInsideContainer.rel = "noopener noreferrer";
        HREFInsideContainer.href = SortingBannerData[WhichBannerIndex].banner.direct_link;
        PopUpIndexImageContainer.append(HREFInsideContainer);
    }
}

// ---------------------------------- LOAD SLIDE POP UP BANNER ----------------------------------

async function LoadSlidePopUpInfo(SlidePopUpContainer)
{
    // Load The Slide Data -------------------------------

    let SortingSlideBannerURL = "/v2/banners/slide";

    try
    {
        const res = await window.CallApiAxios({
            method: "GET",
            url: SortingSlideBannerURL,
        });

        //console.log(SortingSlideBannerURL);

        if (res.status == 200)
        {
            let SlideBannerSortingBannerData = res.data.data;
            //console.log(SlideBannerSortingBannerData);

            // If Data is Not Null or More than 0 Instantiate The Container ---------------------------------

            if(SlideBannerSortingBannerData != null && SlideBannerSortingBannerData.length > 0) // If Data Exist Instantiate -----------------------------
            {
                let SectionContentWrapper = document.createElement("div"); // Main Swiper -----------------
                SectionContentWrapper.className = "SectionContentWrapper";
                SlidePopUpContainer.append(SectionContentWrapper);
                
                let BasicPanelSwiperMainContainer = document.createElement("div");
                BasicPanelSwiperMainContainer.className = "BasicPanelSwiperMainContainer";
                SectionContentWrapper.append(BasicPanelSwiperMainContainer);

                let ContainerWithMaskEdge = document.createElement("div");
                ContainerWithMaskEdge.className = "ContainerWithMaskEdge";
                BasicPanelSwiperMainContainer.append(ContainerWithMaskEdge);

                let SliderPopUpSwiperContainer = document.createElement("div");
                SliderPopUpSwiperContainer.className = "SliderHomeContainer";
                ContainerWithMaskEdge.append(SliderPopUpSwiperContainer);

                let SwiperWrapper = document.createElement('div');
                SwiperWrapper.className = "swiper-wrapper";
                SliderPopUpSwiperContainer.append(SwiperWrapper);

                for(let i = 0; i < SlideBannerSortingBannerData.length; i++)
                {
                    let SlidePopUpSwiperSlide = document.createElement('div');
                    SlidePopUpSwiperSlide.className = "SlidePopUpSwiperSlide swiper-slide Selectable2 BasicRoundRadius";
                    SwiperWrapper.append(SlidePopUpSwiperSlide);

                    let ImageSlideDesktop = document.createElement('img');
                    ImageSlideDesktop.className = "SlidePopUpDesktopImg";
                    ImageSlideDesktop.src = SlideBannerSortingBannerData[i].banner.slide_image_desktop;
                    SlidePopUpSwiperSlide.append(ImageSlideDesktop);

                    let ImageSlideMobile = document.createElement('img');
                    ImageSlideMobile.className = "SlidePopUpMobileImg";
                    ImageSlideMobile.src = SlideBannerSortingBannerData[i].banner.slide_image_mobile;
                    SlidePopUpSwiperSlide.append(ImageSlideMobile);

                    if(SlideBannerSortingBannerData[i].banner.direct_link != "")
                    {
                        let SlideBannerHREF = document.createElement("a");
                        SlideBannerHREF.className = "HREFInsideContainer";
                        SlideBannerHREF.href = SlideBannerSortingBannerData[i].banner.direct_link;
                        SlidePopUpSwiperSlide.append(SlideBannerHREF);
                    }
                }

                let ButtonPrevWrapper = document.createElement("div"); // Prev Button -----------------
                ButtonPrevWrapper.className = "PopularAreasLeftRightButtonContainer PaddingButtonLeft";
                BasicPanelSwiperMainContainer.append(ButtonPrevWrapper);

                let ButtonPrevBtn = document.createElement("button");
                ButtonPrevBtn.className = "NextPreviousSwiperButton Selectable2 PopUpSlideButtonPrev";
                ButtonPrevWrapper.append(ButtonPrevBtn);

                let ButtonPrevBtnImage = document.createElement("img");
                ButtonPrevBtnImage.src = "/Assets/images/ButtonIcon/chevron.svg";
                ButtonPrevBtn.append(ButtonPrevBtnImage);


                let ButtonNextWrapper = document.createElement("div"); // Next Button -----------------
                ButtonNextWrapper.className = "PopularAreasLeftRightButtonContainer PaddingButtonRight";
                BasicPanelSwiperMainContainer.append(ButtonNextWrapper);

                let ButtonNextBtn = document.createElement("button");
                ButtonNextBtn.className = "NextPreviousSwiperButton Selectable2 PopUpSlideButtonNext";
                ButtonNextWrapper.append(ButtonNextBtn);

                let ButtonNextBtnImage = document.createElement("img");
                ButtonNextBtnImage.src = "/Assets/images/ButtonIcon/chevron.svg";
                ButtonNextBtn.append(ButtonNextBtnImage);


                let BasicYellowPaginationContainer = document.createElement("div"); // Pagination -----------------
                BasicYellowPaginationContainer.className = "swiper-pagination BasicYellowPaginationContainer";
                SectionContentWrapper.append(BasicYellowPaginationContainer);

                SlidePopUpContainer.style.display = "";

                let PopUpSliderSwiper = new window.Swiper(SliderPopUpSwiperContainer,
                {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    freeMode: true,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        prevEl: ButtonPrevWrapper,
                        nextEl: ButtonNextWrapper,
                    },
                    pagination:{
                        el: BasicYellowPaginationContainer,
                        clickable: true,
                    },
                });
            }
            else
            {
                SlidePopUpContainer.remove();
            }
        }
        else
        {
            SlidePopUpContainer.remove();
        }
    }
    catch (err)
    {
        //console.error(err);
        SlidePopUpContainer.remove();
    }
}